import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
  FormControl,
  Alert,
  IconButton,
  Collapse,
  OutlinedInput,
  Checkbox,
  FormControlLabel,
  Chip,
  Radio,
  RadioGroup,
  FormLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import "@ag-grid-community/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-community/all-modules/dist/styles/ag-theme-material.css";
import "ag-grid-enterprise";
import axios from "axios";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { toast } from "react-toastify";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../../utils/apiUtils";
import { BASE_SPRING_ENDPOINT } from "../../../utils/apiUtils/config";
import ReportsLoader from "./ReportsLoader";
import { channelLogoMap } from "../../../utils/common/CallenderConstants";
import {
  razorPayKey,
  springBaseUrl,
} from "../../../utils/common/AmplitudeConstants";
import { sideBar } from "../../../utils/common/sidebar.js";
import CustomDateComponent from "./customDateComponent";
import {
  extractCreatedLedgerId,
  findLatestMatchingManualEntryId,
  getEligibleNonIndiaInvoiceIds,
  isSubscriptionDebitLedger,
  shouldShowManualGenerateInvoiceCheckbox,
} from "./transactionsInvoiceUtils";
import {
  calculateTdsBifurcation,
  getTdsPercentage,
  isTdsEnabled,
  isEligibleForPayNow,
  getNetPayableAmount,
  formatCurrency,
} from "./tdsUtils";
import "./acc.css";

const TransactionsManagement = (props) => {
  console.log("props", props);
  const getLocalDateString = (date = new Date()) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getMonthDateRange = (monthOffset = 0, baseDate = new Date()) => {
    const start = new Date(
      baseDate.getFullYear(),
      baseDate.getMonth() + monthOffset,
      1
    );
    const end = new Date(
      baseDate.getFullYear(),
      baseDate.getMonth() + monthOffset + 1,
      0
    );

    return {
      startDate: getLocalDateString(start),
      endDate: getLocalDateString(end),
    };
  };

  const getErrorMessage = (
    err,
    fallbackMessage = "Something went wrong. Please try again."
  ) => {
    if (
      typeof err?.response?.data === "string" &&
      err.response.data.trim().length > 0
    ) {
      return err.response.data;
    }
    if (
      typeof err?.response?.data?.message === "string" &&
      err.response.data.message.trim().length > 0
    ) {
      return err.response.data.message;
    }
    if (typeof err?.message === "string" && err.message.trim().length > 0) {
      return err.message;
    }
    return fallbackMessage;
  };

  const [ledger, setLedger] = useState(null);
  const [accBalance, setAccBalance] = useState(null);
  const [hotelCurr, setHotelCurr] = useState(null);
  const [groupId, setGroupId] = useState(null);
  const [accountInfo, setAccountInfo] = useState(null);
  const [rowsData, setRowsData] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [selectedRowsLength, setSelectedRowsLength] = useState(0);
  const [filterCount, setFilterCount] = useState(0);
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [contact, setcontact] = useState("");
  const [authType, setauthType] = useState("netbanking");
  const [beneName, setbeneName] = useState("");
  const [accNumber, setaccNumber] = useState(0);
  const [accountType, setaccountType] = useState("savings");
  const [ifsc, setifsc] = useState("");
  const [customerId, setcustomerId] = useState("");
  const [orderId, setorderId] = useState("");
  const [indPaymentMethod, setindPaymentMethod] = useState(false);
  const [indPaymentDetail, setindPaymentDetail] = useState(null);
  const [isValidHash, setIsValidHash] = useState(false);
  const [openAccountingVersionModal, setOpenAccountingVersionModal] =
    useState(false);
  const handleOpenAccountingVersionModalOpen = () =>
    setOpenAccountingVersionModal(true);
  const handleOpenAccountingVersionModalClose = () =>
    setOpenAccountingVersionModal(false);
  const [createBillingSchedule, setCreateBillingSchedule] = useState(false);
  const handleOpenCreateBillingSchedule = () => setCreateBillingSchedule(true);
  const handleCreateBillingScheduleClose = () => {
    setdayError(false);
    setCreateBillingSchedule(false);
  };
  const [deleteBillingSchedule, setDeleteBillingSchedule] = useState(false);
  const handleOpenDeleteBillingSchedule = () => setDeleteBillingSchedule(true);
  const handleDeleteBillingScheduleClose = () => {
    setDeleteBillingSchedule(false);
  };

  const [createManualEntry, setCreateManualEntry] = useState(false);

  const [generateInvoices, setGenerateInvoices] = useState(false);
  const handleOpenGenerateInvoices = () => setGenerateInvoices(true);
  const handleGenerateInvoicesClose = () => {
    setGenerateInvoices(false);
  };

  const [bulkGenerateInvoices, setBulkGenerateInvoices] = useState(false);
  const handleOpenBulkGenerateInvoices = () => setBulkGenerateInvoices(true);
  const handleBulkGenerateInvoicesClose = () => {
    setBulkGenerateInvoices(false);
  };

  const [voidInvoices, setVoidInvoices] = useState(false);
  const handleOpenVoidInvoices = () => setVoidInvoices(true);
  const handleVoidInvoicesClose = () => {
    setVoidInvoices(false);
  };

  const [showPaymentLink, setshowPaymentLink] = useState(false);

  const handleOpenshowPaymentLink = () => setshowPaymentLink(true);
  const handleCloseShowPaymentLink = () => setshowPaymentLink(false);

  // Pay Now modal state for invoice payments
  const [payNowModalOpen, setPayNowModalOpen] = useState(false);
  const [payNowLedgerEntry, setPayNowLedgerEntry] = useState(null);
  const [payNowLoading, setPayNowLoading] = useState(false);

  const handleOpenPayNowModal = (ledgerEntry) => {
    setPayNowLedgerEntry(ledgerEntry);
    setPayNowModalOpen(true);
  };

  const handleClosePayNowModal = () => {
    setPayNowModalOpen(false);
    setPayNowLedgerEntry(null);
  };

  const [mAmount, setMAmount] = useState("");
  const [mType, setMType] = useState("DEBIT");
  const [mMode, setMMode] = useState("SUBSCRIPTION");
  const [source, setSource] = useState("OTHER");
  const [mDescription, setMDescription] = useState("");
  const [charge, setCharge] = useState(false);
  const [sendEmail, setsendEmail] = useState(false);
  const [generateInvoiceOnCreate, setGenerateInvoiceOnCreate] = useState(false);
  const [manualPaymentMethods, setManualPaymentMethods] = useState([]);
  const [selectedManualPaymentMethodId, setSelectedManualPaymentMethodId] =
    useState("");
  const [manualPaymentMethodLoading, setManualPaymentMethodLoading] =
    useState(false);
  const [terminalId, setterminalId] = useState("PRE");

  const [startDate, setStartDate] = useState(getLocalDateString());

  const [endDate, setEndDate] = useState(getLocalDateString());

  const [startDateUpdate, setStartDateUpdate] = useState("");

  const [endDateUpdate, setEndDateUpdate] = useState("");
  const [paymentMethods, setPaymentMethods] = useState([]);

  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState("defaultMethod");

  const resetManualEntryForm = () => {
    setMAmount("");
    setMType("DEBIT");
    setMMode("SUBSCRIPTION");
    setSource("OTHER");
    setMDescription("");
    setCharge(false);
    setsendEmail(false);
    setGenerateInvoiceOnCreate(false);
    setStartDate(getLocalDateString());
    setEndDate(getLocalDateString());
    setManualPaymentMethods([]);
    setSelectedManualPaymentMethodId("");
    setManualPaymentMethodLoading(false);
  };

  const handleOpenCreateManualEntry = () => {
    resetManualEntryForm();
    setCreateManualEntry(true);
  };
  const handleCreateManualEntryClose = () => {
    setCreateManualEntry(false);
    resetManualEntryForm();
  };

  const handleSendEmailCheckboxChecked = (e) => {
    // console.log("e.target.checked : ", e.target.checked);
    if (e.target.checked) {
      setsendEmail(true);
    } else {
      setsendEmail(false);
    }
  };
  const handleCheckboxChecked = (e) => {
    if (e.target.checked) {
      setCharge(true);
    } else {
      setCharge(false);
    }
  };
  const handleGenerateInvoiceOnCreateChange = (e) => {
    setGenerateInvoiceOnCreate(e.target.checked);
  };

  const showManualGenerateInvoiceCheckbox =
    shouldShowManualGenerateInvoiceCheckbox({
      hotelCurr,
      type: mType,
      mode: mMode,
    });

  useEffect(() => {
    if (!showManualGenerateInvoiceCheckbox && generateInvoiceOnCreate) {
      setGenerateInvoiceOnCreate(false);
    }
  }, [showManualGenerateInvoiceCheckbox, generateInvoiceOnCreate]);

  const getManualPaymentMethodLabel = (paymentMethod) => {
    if (!paymentMethod) {
      return "";
    }

    const isPrimary = paymentMethod?.active === "YES";
    const primaryText = isPrimary ? " (Primary)" : "";

    if (paymentMethod?.payment_method_type === "account") {
      const accountType = paymentMethod?.ach_account_type
        ? paymentMethod?.ach_account_type?.toUpperCase()
        : "ACCOUNT";
      const last4 = paymentMethod?.ach_account_last4 || "XXXX";
      return `${accountType} ****${last4}${primaryText}`;
    }

    const issuer = paymentMethod?.card_issuer
      ? paymentMethod?.card_issuer?.toUpperCase()
      : "CARD";
    const cardType = paymentMethod?.card_type
      ? paymentMethod?.card_type?.toUpperCase()
      : "CARD";
    const last4 = paymentMethod?.card_last4 || "XXXX";
    return `${issuer} ${cardType} ****${last4}${primaryText}`;
  };

  const fetchManualCreditPaymentMethods = () => {
    if (!groupId) {
      return;
    }
    setManualPaymentMethodLoading(true);
    handleSpringDataRequest(
      `core/api/v1/account-payment-method/get-all?groupId=${groupId}&hotelId=${groupId}`
    )
      .then((res) => {
        const paymentMethods = Array.isArray(res) ? res : [];
        setManualPaymentMethods(paymentMethods);

        const activePaymentMethod = paymentMethods.find(
          (paymentMethod) => paymentMethod?.active === "YES"
        );
        const defaultPaymentMethod =
          activePaymentMethod ||
          (paymentMethods?.length > 0 ? paymentMethods[0] : null);

        setSelectedManualPaymentMethodId(
          defaultPaymentMethod?.id ? String(defaultPaymentMethod.id) : ""
        );
      })
      .catch(() => {
        setManualPaymentMethods([]);
        setSelectedManualPaymentMethodId("");
      })
      .finally(() => {
        setManualPaymentMethodLoading(false);
      });
  };

  useEffect(() => {
    if (createManualEntry && mType === "CREDIT") {
      fetchManualCreditPaymentMethods();
    }
  }, [createManualEntry, mType, groupId]);

  useEffect(() => {
    props && setLedger(props?.ledger);
    props && setRowsData(props?.ledger);
    props && setAccBalance(parseFloat(props?.accBalance).toFixed(2));
    props && setHotelCurr(props?.curr);
    props && setGroupId(props?.groupId);
    props && setAccountInfo(props?.res);
  }, [props]);

  const [currSymbol, setCurrSymbol] = useState(null);
  useEffect(() => {
    let curr = hotelCurr === "INR" ? "Rs." : "$";
    // const datass = Currencies?.filter((item) => {
    //   if (item.code === hotelCurr) {
    //     curr = item.symbol;
    //   }
    // });
    setCurrSymbol(curr);
  }, [hotelCurr]);

  const [depositLoading, setDepositLoading] = useState(false);
  const [depositAmt, setDepositAmt] = useState(0);

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openindPay, setopenindPay] = useState(false);

  const handleindPayOpen = () => setopenindPay(true);
  const handleindPayClose = () => setopenindPay(false);

  const [banneropen, setBannerOpen] = useState(true);

  const handleBannerOpen = () => setBannerOpen(true);
  const handleBannerClose = () => setBannerOpen(false);

  const [pmDetails, setPmDetails] = useState(null);
  const [nextPaymentSchedule, setnextPaymentSchedule] = useState(null);

  const [genericLoad, setgenericLoad] = useState(false);
  const [dayError, setdayError] = useState(false);
  const [pickDate, setPickDate] = useState(getLocalDateString());
  const handlePickDateChange = (newValue) => {
    let value = newValue?.target?.value?.split("-")[2];
    // console.log("newValue : ", newValue?.target?.value);
    if (parseInt(value) !== 1) {
      setdayError(true);
    } else {
      setdayError(false);
    }
    setPickDate(newValue?.target?.value);
  };

  const changeAccountingVersion = () => {
    setgenericLoad(true);
    handleSpringDataMutationRequest(
      "PUT",
      `core/api/v1/account/change-accounting-version?groupId=${groupId}&version=2`,
      {}
    )
      .then(async (res) => {
        toast.success("Successfully update accounting version");
        handleOpenAccountingVersionModalClose();
        setgenericLoad(false);
        const datass = await props?.getCompanyData1();
        const datasss = await props?.getCompanyData2();
        const data = props?.getLedgerData();
        const datas = props?.getAccountBalance();
        getIndianPaymentMethodDetails();
        fetchPaymentMethodData();
        getNextInvoicingSchedule();
      })
      .catch((err) => {
        toast.success("Something went wrong, Please try again later");
        handleOpenAccountingVersionModalClose();
        setgenericLoad(false);
      });
  };
  const dateConversion = (newDate) => {
    const [year, month, day] = newDate.split("-").map(Number);
    const dateObject = new Date(year, month - 1, day);
    return dateObject;
  };
  const createBillingScheduleAPI = () => {
    setgenericLoad(true);
    let finalDateValue = moment(dateConversion(pickDate)).format(
      "DD-MM-YYYY HH:mm:ss"
    );
    let value = moment(dateConversion(pickDate))
      .format("DD-MM-YYYY")
      .split("-")[0];
    // console.log("value : ", value, finalDateValue);
    if (parseInt(value) !== 1) {
      setdayError(true);
      setgenericLoad(false);
      return;
    }

    handleSpringDataRequest(
      `core/api/v1/payment-schedule/createBillingSchedule?groupId=${groupId}&startDate=${finalDateValue}&billingType=${terminalId}`
    )
      .then((res) => {
        // setPickDate(new Date());
        handleCreateBillingScheduleClose();
        setgenericLoad(false);
        const data = props?.getLedgerData();
        const datas = props?.getAccountBalance();
        getIndianPaymentMethodDetails();
        fetchPaymentMethodData();
        getNextInvoicingSchedule();
      })
      .catch((err) => {
        // setPickDate(new Date());
        handleCreateBillingScheduleClose();
        setgenericLoad(false);
        console.log("The err is : ", err);
      });
  };

  const deleteBillingScheduleAPI = () => {
    setgenericLoad(true);
    handleSpringDataRequest(
      `core/api/v1/payment-schedule/deleteBillingSchedule?groupId=${groupId}`
    )
      .then((res) => {
        handleDeleteBillingScheduleClose();
        setgenericLoad(false);
        const data = props?.getLedgerData();
        const datas = props?.getAccountBalance();
        getIndianPaymentMethodDetails();
        fetchPaymentMethodData();
        getNextInvoicingSchedule();
      })
      .catch((err) => {
        handleDeleteBillingScheduleClose();
        setgenericLoad(false);
        console.log("The err is : ", err);
      });
  };

  const refreshBillingData = () => {
    props?.getLedgerData();
    props?.getAccountBalance();
    getIndianPaymentMethodDetails();
    fetchPaymentMethodData();
    getNextInvoicingSchedule();
  };

  const fetchLatestLedgerEntries = () => {
    return handleSpringDataRequest(
      `core/api/v1/account-ledger/get-all-invoices?groupId=${groupId}&hotelId=${groupId}`
    );
  };

  const generateInvoicesForLedgerIds = (ledgerIds) => {
    return handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/account-ledger/generate-invoices`,
      {
        invoice_ids: ledgerIds,
        group_id: groupId,
      }
    );
  };

  const createManualEntryAPI = () => {
    if (mAmount === null || mAmount === undefined || mAmount === "") {
      toast.error("Please enter a valid amount");
      return;
    }
    if (mType === null || mType === undefined || mType === "") {
      toast.error("Please enter a valid type");
      return;
    }
    if (mMode === null || mMode === undefined || mMode === "") {
      toast.error("Please enter a valid mode");
      return;
    }

    if (!mDescription.trim()) {
      toast.error("Please enter a valid description");
      return;
    }
    // if(mAmount || mAmount === undefined || mAmount === ""){
    //     toast.error("Please enter a valid amount");
    //     return;
    // }
    setgenericLoad(true);
    if (mType === "DEBIT") {
      const payload = {
        customLedgerId: "1111",
        groupId: groupId,
        description: mDescription,
        amount: mAmount,
        mode: mMode,
        type: mType,
        startDate: startDate,
        endDate: endDate,
        status: "SUCCESS",
      };
      handleSpringDataMutationRequest(
        "POST",
        `core/api/v1/account-ledger/create-manual-entry?sendEmail=${sendEmail}`,
        payload
      )
        .then(async (res) => {
          if (!generateInvoiceOnCreate) {
            toast.success("Successfully added debit entry");
            refreshBillingData();
            setgenericLoad(false);
            handleCreateManualEntryClose();
            return;
          }

          try {
            let createdLedgerId = extractCreatedLedgerId(res);

            if (!Number.isFinite(createdLedgerId)) {
              const latestLedgerEntries = await fetchLatestLedgerEntries();
              createdLedgerId = findLatestMatchingManualEntryId(
                latestLedgerEntries,
                {
                  amount: mAmount,
                  type: mType,
                  mode: mMode,
                  description: mDescription,
                  startDate,
                  endDate,
                }
              );
            }

            if (!Number.isFinite(createdLedgerId)) {
              toast.error(
                "Debit entry was created, but invoice generation could not be completed."
              );
              refreshBillingData();
              setgenericLoad(false);
              handleCreateManualEntryClose();
              return;
            }

            await generateInvoicesForLedgerIds([createdLedgerId]);
            toast.success(
              "Successfully added debit entry and generated invoice"
            );
            refreshBillingData();
            setgenericLoad(false);
            handleCreateManualEntryClose();
          } catch (invoiceErr) {
            toast.error(
              getErrorMessage(
                invoiceErr,
                "Debit entry was created, but invoice generation could not be completed."
              )
            );
            refreshBillingData();
            setgenericLoad(false);
            handleCreateManualEntryClose();
          }
        })
        .catch((err) => {
          console.log("The err is : ", err);
          setgenericLoad(false);
          handleCreateManualEntryClose();
        });
    }
    if (mType === "CREDIT") {
      let shouldCharge = "NO";
      if (charge || selectedPaymentMethod !== "defaultMethod") {
        shouldCharge = "YES";
      }
      if (charge && !selectedManualPaymentMethodId) {
        toast.error(
          "No payment method selected. Please choose one or add it in Payment Methods tab."
        );
        setgenericLoad(false);
        return;
      }

      const description =
        selectedPaymentMethod === "defaultMethod"
          ? mDescription
          : `${mDescription} Charged by - ${
              cardsGetStartMap[selectedPaymentMethod?.card_issuer] +
              (selectedPaymentMethod?.ach_account_last4 ||
                selectedPaymentMethod?.card_last4)
            }`;
      const payload = {
        customLedgerId: "1111",
        groupId: groupId,
        description: description,
        amount: parseFloat(mAmount),
        mode: mMode,
        source: source,
        type: mType,
        startDate: startDate,
        endDate: endDate,
        status: "SUCCESS",
        currency: hotelCurr,
      };

      const endpoint = selectedManualPaymentMethodId
        ? `core/api/v1/account-ledger/create-manual-credit-entry-payment-method-charge?paymentMethodId=${selectedManualPaymentMethodId}&charge=${shouldCharge}&sendEmail=${sendEmail}`
        : `core/api/v1/account-ledger/create-manual-credit-entry?charge=${shouldCharge}&sendEmail=${sendEmail}`;

      handleSpringDataMutationRequest("POST", endpoint, payload)
        .then((res) => {
          toast.success(res);
          refreshBillingData();
          setgenericLoad(false);
          handleCreateManualEntryClose();
        })
        .catch((err) => {
          toast.error(
            getErrorMessage(
              err,
              "Unable to add credit entry. Please try again later."
            )
          );
          refreshBillingData();
          setgenericLoad(false);
          handleCreateManualEntryClose();
        });
    }
  };
  //----------------------------
  const fetchPaymentMethodData = () => {
    handleSpringDataRequest(
      `core/api/v1/account-payment-method/get-active-payment-method?groupId=${groupId}&hotelId=${groupId}`
    )
      .then((res) => {
        setPmDetails(res?.[0]);
      })
      .catch((err) => {
        toast.error("No active payment method is set for the account");
        setDepositAmt(0);
        handleClose();
        console.log("The err is : ", err);
      });
  };

  const fetchPaymentMethodData2 = () => {
    handleSpringDataRequest(
      `core/api/v1/account-payment-method/get-active-payment-method?groupId=${groupId}&hotelId=${groupId}`
    )
      .then((res) => {
        if (res && res?.length > 0) {
          setPmDetails(res?.[0]);
          handleOpen();
        } else {
          toast.error(
            "No active payment method is set for the account, please setup payment method in Payment methods tab."
          );
        }
        // console.log("active payment method : ", res);
      })
      .catch((err) => {
        toast.error("No active payment method is set for the account");
        setDepositAmt(0);
        handleClose();
        console.log("The err is : ", err);
      });
  };

  const [nextPaySchedule, setNextPaySchedule] = useState(null);
  //----------------------
  const getNextInvoicingSchedule = () => {
    handleSpringDataRequest(
      `core/api/v1/payment-schedule/get-all-schedule?groupId=${groupId}&hotelId=${groupId}`
    )
      .then((res) => {
        // setPmDetails(res[0]);
        console.log("next payment schedule : ", res);
        if (res && res !== undefined && res !== "FAILED") {
          setNextPaySchedule(res);
        }
      })
      .catch((err) => {
        // toast.error("No active payment method is set for the account");
        // setDepositAmt(0);
        // handleClose();
        setNextPaySchedule(null);
        console.log("The err is : ", err);
      });
    // axios
    //   .get(
    //     `${BASE_SPRING_ENDPOINT}` +
    //       `core/api/v1/payment-schedule/get-all-schedule?groupId=${groupId}&hotelId=${groupId}`
    //   )
    //   .then((res) => {
    //     // setPmDetails(res[0]);
    //     console.log("next payment schedule : ", res);
    //     if (res && res !== undefined && res?.data !== "FAILED") {
    //       setNextPaySchedule(res?.data);
    //     }
    //   })
    //   .catch((err) => {
    //     // toast.error("No active payment method is set for the account");
    //     // setDepositAmt(0);
    //     // handleClose();
    //     setNextPaySchedule(null);
    //     console.log("The err is : ", err);
    //   });
  };
  //-------------------
  const getIndianPaymentMethodDetails = () => {
    handleSpringDataRequest(
      `core/api/v1/account-payment-method/get-account-payment-method-india?groupId=${groupId}&hotelId=${groupId}`
    )
      .then((res) => {
        console.log("Result is : ", res);
        if (res && res !== undefined && res !== "FAILED") {
          setindPaymentMethod(true);
          setindPaymentDetail(res);
        }
      })
      .catch((err) => {
        console.log("Error is : ", err);
        setindPaymentMethod(false);
      });
  };

  useEffect(() => {
    if (groupId) {
      getIndianPaymentMethodDetails();
      fetchPaymentMethodData();
      getNextInvoicingSchedule();
    }
  }, [groupId]);

  const handleFortisPayment = () => {
    setDepositLoading(true);
    setRowsData(null);
    let mode = pmDetails?.payment_method_type === "account" ? "ach" : "cc";
    // console.log("pmdetails are : ", pmDetails);
    let amt = depositAmt.toString();
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/account-payment-method/fortis_process_transaction/?groupId=${groupId}&hotelId=${groupId}&mode=${mode}&amt=${amt}`,
      pmDetails
    )
      .then((res) => {
        // console.log("The fortis result is : ", res);
        toast.success(res.responseMessageStr);
        setDepositAmt(0);
        handleClose();
        const data = props?.getLedgerData();
        const datas = props?.getAccountBalance();
        setDepositLoading(false);
      })
      .catch((err) => {
        console.log("the err is : ", err);
        toast.error(err);
        setDepositAmt(0);
        handleClose();
        setDepositLoading(false);
      });
  };

  const [razorpayFinalKey, setRazorpayFinalKey] = useState(razorPayKey);
  const [imageUrl, setImageUrl] = useState(channelLogoMap.STAYFLEXI_OM);
  const [tableLoader, setTableLoader] = useState(false);

  const payloadForRazorpay = {
    group_id: groupId,
    "razorpay-pg-id": "",
    amount: 0,
    currency: "INR",
  };

  // Razorpay
  var options = {
    key: razorpayFinalKey,
    amount: "100",
    currency: "INR",
    name: "Stayflexi",
    description: "Recharge account",
    image: imageUrl,
    // order_id: "", //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
    handler: function (response) {
      setTableLoader(true);
      setRowsData(null);
      payloadForRazorpay["razorpay-pg-id"] = response.razorpay_payment_id;
      handleSpringDataMutationRequest(
        "POST",
        `core/api/v1/payments/razorpay/capture-payment/?groupId=${groupId}&hotelId=${groupId}`,
        payloadForRazorpay
      )
        .then((resp) => {
          toast.success(resp);
          const data = props?.getLedgerData();
          const datas = props?.getAccountBalance();
          setRazorpayAmount(0);
          setTableLoader(false);
        })
        .catch((err) => {
          toast.error(err);
          setTableLoader(false);
        });
      // alert(response.razorpay_payment_id);
      // alert(response.razorpay_order_id);
      // alert(response.razorpay_signature);
    },
    prefill: {
      name: accountInfo?.account_details?.account_name,
      email: accountInfo?.account_details?.account_billing_email,
      contact: "",
    },
    notes: {
      account_id: groupId,
      module_source: "ACCOUNT_PAYMENT_LINK",
    },
    theme: {
      color: "#1ab394",
      hide_topbar: false,
    },
  };

  const [errorShow, setErrorShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const invokeRazorpayModal = () => {
    payloadForRazorpay["amount"] = options["amount"];
    let rzp1 = new window.Razorpay(options);
    rzp1.open();
    rzp1.on("payment.failed", function (response) {
      setErrorShow(true);
      setErrorMessage(response?.error?.description);
      setTimeout(() => {
        setErrorShow(false);
      }, 4000);
    });
  };
  const [razorpayAmount, setRazorpayAmount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [openAmountModal, setOpenAmountModal] = useState(false);

  const handleAmountClose = () => setOpenAmountModal(false);
  const handleAmountOpen = () => setOpenAmountModal(true);

  // open={openEmandateModal}
  // onClose={handleCloseOpenEmandateModal}
  const [openEmandateModal, setOpenEmandateModal] = useState(false);

  const handleoOpenEmandateModal = () => setOpenEmandateModal(true);
  const handleCloseOpenEmandateModal = () => {
    setname("");
    setemail("");
    setcontact("");
    setauthType("netbanking");
    setbeneName("");
    setaccNumber(0);
    setaccountType("savings");
    setifsc("");
    setOpenEmandateModal(false);
  };

  useEffect(() => {
    if (props && props?.accBalance && props?.accBalance < 0) {
      let amt = props?.accBalance * -1;
      let toSetamt = amt.toString().split(".")[0];
      setRazorpayAmount(toSetamt);
      setDepositAmt(toSetamt);
    }
  }, [props, props?.accBalance]);

  // Pay Now Razorpay handler for invoice payments
  const handlePayNowRazorpay = async (ledgerEntry) => {
    if (!ledgerEntry || !groupId) {
      toast.error("Invalid payment request");
      return;
    }

    setPayNowLoading(true);

    const grossAmount = parseFloat(ledgerEntry.amount) || 0;
    const tdsPercent = getTdsPercentage(accountInfo?.account_details);
    const { netPayable, tdsAmount } = calculateTdsBifurcation(
      grossAmount,
      tdsPercent
    );

    const amountInPaise = Math.round(netPayable * 100);

    const payNowPayloadForRazorpay = {
      group_id: groupId,
      "razorpay-pg-id": "",
      amount: amountInPaise,
      currency: hotelCurr || "INR",
      ledger_id: ledgerEntry.id,
      gross_amount: grossAmount,
      tds_percentage: tdsPercent,
      tds_amount: tdsAmount,
      net_payable: netPayable,
    };

    const payNowOptions = {
      key: razorpayFinalKey,
      amount: amountInPaise.toString(),
      currency: hotelCurr || "INR",
      name: "Stayflexi",
      description: `Payment for Invoice #${ledgerEntry.id}`,
      image: imageUrl,
      handler: async function (response) {
        try {
          setPayNowLoading(true);
          payNowPayloadForRazorpay["razorpay-pg-id"] =
            response.razorpay_payment_id;

          // Capture the payment and generate invoice
          const captureResult = await handleSpringDataMutationRequest(
            "POST",
            `core/api/v1/payments/razorpay/capture-invoice-payment/?groupId=${groupId}&hotelId=${groupId}&ledgerId=${ledgerEntry.id}`,
            payNowPayloadForRazorpay
          );

          toast.success(
            captureResult?.message ||
              "Payment successful! GST Invoice generated and sent."
          );

          // Refresh data
          refreshAccountLedgerData();
          handleClosePayNowModal();
          setPayNowLoading(false);
        } catch (err) {
          console.error("Payment capture error:", err);
          toast.error(
            getErrorMessage(
              err,
              "Payment received but invoice generation failed. Please contact support."
            )
          );
          refreshAccountLedgerData();
          handleClosePayNowModal();
          setPayNowLoading(false);
        }
      },
      prefill: {
        name: accountInfo?.account_details?.account_name || "",
        email: accountInfo?.account_details?.account_billing_email || "",
        contact: accountInfo?.account_details?.account_billing_phone || "",
      },
      notes: {
        account_id: groupId,
        ledger_id: ledgerEntry.id,
        module_source: "ACCOUNT_INVOICE_PAYMENT",
        gross_amount: grossAmount,
        tds_percentage: tdsPercent,
        tds_amount: tdsAmount,
        net_payable: netPayable,
      },
      theme: {
        color: "#1ab394",
        hide_topbar: false,
      },
      modal: {
        ondismiss: function () {
          setPayNowLoading(false);
          toast.info("Payment cancelled");
        },
      },
    };

    try {
      const rzp = new window.Razorpay(payNowOptions);
      rzp.open();
      rzp.on("payment.failed", function (response) {
        setPayNowLoading(false);
        toast.error(
          response?.error?.description || "Payment failed. Please try again."
        );
      });
    } catch (err) {
      setPayNowLoading(false);
      toast.error("Unable to initialize payment. Please try again.");
    }
  };

  const rowSelectionType = "multiple";

  const onPaginationChange = (pageSize) => {
    gridApi.paginationSetPageSize(pageSize);
    // console.log("");
  };

  // quick search
  const onFilterTextChange = (event) => {
    // console.log(event.target.value)
    setFilterCount((prevCount) => prevCount + 1);
    // console.log("filterCount", filterCount)
    gridApi.setQuickFilter(event.target.value);
  };

  const [allCols, setAllCols] = useState(null);
  const [colmap, setColmap] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    setAllCols(params?.columnApi?.columnController?.columnDefs);
    // console.log("defs  : ", params.columnApi.columnController);
    const mp = new Map();
    const dt = params?.columnApi?.columnController?.columnDefs.map(
      (res, idx) => {
        //   console.log("index is : ", idx, "    ", res.field);
        mp.set(res.field, {
          header: res.headerName,
          hidden: false,
          type: "",
          order: idx + 1,
        });
      }
    );
    setColmap(mp);
    // handleDataRequest("https://beta.stayflexi.com/api/v2/reports/getReportData/?hotel_id=12354&report_type=unifiedBookingReport&start_date=2021-01-01&end_date=2021-12-31&date_filter_mode=checkout")
    // .then((res) => setRowsData(res.report_data))
    // // .then((res) => console.log(console.log(res)))
    // .then((res) => params.api.applyTransaction({add:res}))
  };

  const [load, setload] = useState(false);
  const [sendInvoiceEmailLoadingId, setSendInvoiceEmailLoadingId] =
    useState(null);
  // open={openDInvoice}
  //       onClose={handleCloseDInvoice}
  const [currentLedgerId, setcurrentLedgerId] = useState(null);
  const [openDInvoice, setopenDInvoice] = useState(false);

  const handleOpenDInvoice = (id) => {
    setcurrentLedgerId(id);
    setopenDInvoice(true);
  };

  const handleCloseDInvoice = () => setopenDInvoice(false);

  const downloadInvoice = (id) => {
    setload(true);
    const token = localStorage.getItem("token");
    axios({
      method: "GET",
      url: `${BASE_SPRING_ENDPOINT}core/api/v1/account-ledger/download-invoice/${groupId}/${id}/?groupId=${groupId}&hotelId=${groupId}`,
      headers: {
        Authorization: `${token}`,
      },
      responseType: "blob",
    })
      .then((res) => {
        const contentDisposition = res.headers["content-disposition"];
        let filename = `invoice_${id}.pdf`;
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
          if (match) filename = match[1];
        }
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        setload(false);
        setcurrentLedgerId(null);
        handleCloseDInvoice();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to download invoice");
        setload(false);
        setcurrentLedgerId(null);
        handleCloseDInvoice();
      });
  };

  const sendInvoiceEmail = (id) => {
    setSendInvoiceEmailLoadingId(id);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/account-ledger/send-invoice-email/${groupId}/${id}?groupId=${groupId}&hotelId=${groupId}`,
      {}
    )
      .then((res) => {
        toast.success(res?.message || "Invoice email sent successfully");
        setSendInvoiceEmailLoadingId(null);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Unable to send invoice email. Please try again later");
        setSendInvoiceEmailLoadingId(null);
      });
  };

  const isPostAccountingVersionInvoice = (entry) => {
    return (
      entry?.accounting_version_change_date !== 0 &&
      entry?.invoice_date_epoc !== 0 &&
      entry?.invoice_date_epoc > entry?.accounting_version_change_date
    );
  };

  const hasGeneratedInvoiceSerial = (entry) => {
    return entry?.serial_invoice_id !== "" && entry?.serial_invoice_id !== "-1";
  };

  const getInvoiceStatusForRow = (entry, isInrView) => {
    if (!isSubscriptionDebitLedger(entry)) {
      return isInrView ? "Not generated" : "";
    }

    const isCurrentInvoiceVersion = isPostAccountingVersionInvoice(entry);
    const oldVersionStatus = isInrView ? "Not generated" : "Old invoice";

    if (entry?.serial_invoice_id === "-1") {
      return isCurrentInvoiceVersion ? "Voided" : oldVersionStatus;
    }

    if (entry?.serial_invoice_id !== "") {
      return isCurrentInvoiceVersion ? "Generated" : oldVersionStatus;
    }

    return isCurrentInvoiceVersion ? "Not generated" : oldVersionStatus;
  };

  const canShowInvoiceActions = (entry, isInrView) => {
    if (!isSubscriptionDebitLedger(entry)) {
      return false;
    }

    if (isInrView) {
      return (
        entry?.total_outstanding >= 0 &&
        hasGeneratedInvoiceSerial(entry) &&
        isPostAccountingVersionInvoice(entry)
      );
    }

    return true;
  };

  const renderInvoiceActionsCell = (params, isInrView) => {
    const entry = params?.data;
    const invoiceStatus = getInvoiceStatusForRow(entry, isInrView);
    const showActions = canShowInvoiceActions(entry, isInrView);
    const compactInvoiceActionButtonSx = {
      textTransform: "none",
      minWidth: "unset",
      px: 1,
      fontSize: "0.72rem",
      height: "1.75rem",
      lineHeight: 1.1,
      whiteSpace: "nowrap",
    };
    if (!invoiceStatus && !showActions) {
      return "";
    }

    return (
      <Box
        sx={{
          display: "flex",
          height: "100%",
          alignItems: "center",
          gap: 0.5,
          whiteSpace: "nowrap",
        }}
      >
        <Typography variant="caption">{invoiceStatus || "-"}</Typography>
        {showActions &&
          (isInrView ? (
            <Button
              size="small"
              variant="outlined"
              sx={compactInvoiceActionButtonSx}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleOpenDInvoice(params.value);
              }}
            >
              Download
            </Button>
          ) : (
            <Button
              size="small"
              variant="outlined"
              sx={compactInvoiceActionButtonSx}
              disabled={load}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                downloadInvoice(params.value);
              }}
            >
              Download
            </Button>
          ))}
        {showActions && (
          <Button
            size="small"
            variant="outlined"
            sx={compactInvoiceActionButtonSx}
            disabled={sendInvoiceEmailLoadingId === params.value}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              sendInvoiceEmail(params.value);
            }}
          >
            {sendInvoiceEmailLoadingId === params.value ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              "Send Email"
            )}
          </Button>
        )}
      </Box>
    );
  };

  const [updateEntry, setUpdateEntry] = useState(false);
  const [uAmount, setUAmount] = useState();
  const [uType, setUType] = useState();
  const [uSource, setUsource] = useState("OTHER");
  const [uMode, setUMode] = useState();
  const [uDescription, setUDescription] = useState();
  const [currentId, setCurrentId] = useState(-1);

  const refreshAccountLedgerData = () => {
    props?.getLedgerData();
    props?.getAccountBalance();
    getIndianPaymentMethodDetails();
    fetchPaymentMethodData();
    getNextInvoicingSchedule();
  };

  const resetUpdateLedgerForm = () => {
    setUAmount("");
    setUType("");
    setUsource("OTHER");
    setUMode("");
    setUDescription("");
    setStartDateUpdate("");
    setEndDateUpdate("");
    setCurrentId(-1);
  };

  const handleUpdateEntryOpen = () => setUpdateEntry(true);
  const handleUpdateEnryClose = () => {
    setUpdateEntry(false);
    resetUpdateLedgerForm();
  };

  const applyMonthShortcut = (monthOffset) => {
    const { startDate, endDate } = getMonthDateRange(monthOffset);
    setStartDateUpdate(startDate);
    setEndDateUpdate(endDate);
  };

  const applyCreateMonthShortcut = (monthOffset) => {
    const { startDate, endDate } = getMonthDateRange(monthOffset);
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const updateLedgerEntryAPI = () => {
    if (
      uDescription === null ||
      uDescription === undefined ||
      uDescription === ""
    ) {
      toast.error("Please enter the description");
      return;
    }
    // if (mType === null || mType === undefined || mType === "") {
    //   toast.error("Please enter a valid type");
    //   return;
    // }
    // if (mMode === null || mMode === undefined || mMode === "") {
    //   toast.error("Please enter a valid mode");
    //   return;
    // }
    // if(mAmount || mAmount === undefined || mAmount === ""){
    //     toast.error("Please enter a valid amount");
    //     return;
    // }
    setgenericLoad(true);
    const payload = {
      id: currentId,
      // groupId: groupId,
      description: uDescription,
      amount: uAmount,
      mode: uMode,
      type: uType,
      source: uSource,
      startDate: startDateUpdate,
      endDate: endDateUpdate,
    };
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/account-ledger/update-ledger-entry`,
      payload
    )
      .then((res) => {
        toast.success("Successfully update ledger entry");
        setgenericLoad(false);
        handleUpdateEnryClose();
        refreshAccountLedgerData();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            "Unable to update ledger entry, Please try again later"
        );
        setgenericLoad(false);
        console.log("The err is : ", err);
      });
  };

  const deleteLedgerEntryAPI = () => {
    if (!groupId || currentId === -1) {
      toast.error("Please select a valid ledger entry");
      return;
    }

    const shouldDelete = window.confirm(
      `Do you want to delete ledger entry ${currentId}? This action cannot be undone.`
    );

    if (!shouldDelete) {
      return;
    }

    setgenericLoad(true);
    handleSpringDataMutationRequest(
      "DELETE",
      `core/api/v1/account-ledger/delete-ledger-entry/${groupId}/${currentId}`,
      {}
    )
      .then(() => {
        toast.success("Successfully deleted ledger entry");
        setgenericLoad(false);
        handleUpdateEnryClose();
        refreshAccountLedgerData();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            "Unable to delete ledger entry, Please try again later"
        );
        setgenericLoad(false);
        console.log("Delete ledger entry error : ", err);
      });
  };

  const columnsInr = [
    {
      field: "id",
      headerName: "ID",
      checkboxSelection: true,
      headerCheckboxSelection: true,
      cellRendererFramework: (params) => {
        return (
          <div
            style={{
              // fontSize: "16px",
              cursor: "pointer",
              color: "#49D0C9",
              // fontWeight: "bold",
            }}
            onClick={() => {
              setCurrentId(params.value);
              setUAmount(params.data.amount);
              setUType(params.data.type);
              setUsource(params?.data?.source || "OTHER");
              setUMode(params.data.mode);
              setUDescription(params?.data?.description || "");
              handleUpdateEntryOpen();
              setStartDateUpdate(
                params?.data?.start_date || getLocalDateString()
              );
              setEndDateUpdate(
                params?.data?.end_date || getLocalDateString()
              );
              // console.log("params?.data", params?.data);
              // onOpenMessageModal();
            }}
          >
            <u>{params.value}</u>
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Ledger date",
      //   cellRendererFramework: (params) => cellRenderer(params),

      valueFormatter: (params) => {
        return moment(params.value).format("lll");
      },
    },
    {
      field: "start_date",
      headerName: "Start date",
      valueFormatter: (params) => {
        return moment(params.value).format("ll");
      },
    },
    {
      field: "end_date",
      headerName: "End date",
      valueFormatter: (params) => {
        return moment(params.value).format("ll");
      },
    },
    {
      field: "description",
      headerName: "Description",
      //   valueFormatter: (params) => {
      //     return params.value ? params.value : "-";
      //   },
      hide: false,
    },
    {
      field: "mode",
      headerName: "Mode",
      valueFormatter: (params) => {
        return params?.value?.toUpperCase();
      },
      //   filter: "agDateColumnFilter",
      //   filterParams: filterParams,
      hide: false,
    },
    {
      field: "type",
      headerName: "Type",
      // valueFormatter: (params) => params.value,
    },
    {
      field: "amount",
      headerName: "Amount",
      // valueFormatter: (params) => {
      //   return parseFloat(params.value).toFixed(2);
      // },
      cellRenderer: (params) => {
        // console.log("The params are : ", params.data.type);
        if (params.data.type === "DEBIT") {
          return currSymbol + " " + parseFloat(params.value).toFixed(2);
        } else {
          return currSymbol + " " + parseFloat(params.value).toFixed(2);
        }
        // const updatedBookingId =
        //   "SFBOOKING_" + String(hotelId) + "_" + String(param.value);
        // return (
        //   <Link
        //     to={{
        //       pathname: `/folio/${updatedBookingId}`,
        //       search: `?hotelId=${hotelId}`,
        //     }}
        //     target="_blank"
        //   >
        //     {param.value}
        //   </Link>
        // );
      },
    },
    { field: "status", headerName: "Status" },
    {
      field: "id",
      headerName: "Invoice Actions",
      colId: "invoiceActions",
      sortable: false,
      minWidth: 250,
      cellClass: "invoice-actions-cell",
      cellStyle: { display: "flex", alignItems: "center" },
      cellRendererFramework: (params) => renderInvoiceActionsCell(params, true),
    },
    {
      field: "id",
      headerName: "Payment",
      colId: "payNowAction",
      sortable: false,
      minWidth: 180,
      cellStyle: { display: "flex", alignItems: "center" },
      cellRendererFramework: (params) => {
        const entry = params?.data;
        if (!isEligibleForPayNow(entry)) {
          return entry?.payment_status === "PAID" ||
            entry?.status === "PAID" ? (
            <Chip label="Paid" color="success" size="small" />
          ) : (
            ""
          );
        }
        const tdsPercent = getTdsPercentage(accountInfo?.account_details);
        const { netPayable } = calculateTdsBifurcation(
          parseFloat(entry?.amount),
          tdsPercent
        );
        return (
          <Button
            variant="contained"
            size="small"
            sx={{
              textTransform: "none",
              bgcolor: "#1ab394",
              "&:hover": { bgcolor: "#158a70" },
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleOpenPayNowModal(entry);
            }}
          >
            Pay Now ({formatCurrency(netPayable, hotelCurr)})
          </Button>
        );
      },
    },
  ];

  const columnsUsd = [
    {
      field: "id",
      headerName: "ID",
      checkboxSelection: true,
      headerCheckboxSelection: true,
      cellRendererFramework: (params) => {
        return (
          <div
            style={{
              // fontSize: "16px",
              cursor: "pointer",
              color: "#49D0C9",
              // fontWeight: "bold",
            }}
            onClick={() => {
              setCurrentId(params.value);
              setUAmount(params.data.amount);
              setUType(params.data.type);
              setUsource(params?.data?.source || "OTHER");
              setUMode(params.data.mode);
              setUDescription(params?.data?.description || "");
              handleUpdateEntryOpen();
              setStartDateUpdate(
                params?.data?.start_date || getLocalDateString()
              );
              setEndDateUpdate(
                params?.data?.end_date || getLocalDateString()
              );
              // onOpenMessageModal();
            }}
          >
            <u>{params.value}</u>
          </div>
        );
      },
    },
    {
      field: "date",
      headerName: "Ledger date",
      valueFormatter: (params) => {
        return moment(params.value).format("lll");
      },
    },
    {
      field: "start_date",
      headerName: "Start date",
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format("ll");
        } else {
          return "";
        }
      },
    },
    {
      field: "end_date",
      headerName: "End date",
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format("ll");
        } else {
          return "";
        }
      },
    },
    {
      field: "description",
      headerName: "Description",
      //   valueFormatter: (params) => {
      //     return params.value ? params.value : "-";
      //   },
      hide: false,
    },
    {
      field: "mode",
      headerName: "Mode",
      valueFormatter: (params) => {
        return params?.value?.toUpperCase();
      },
      //   filter: "agDateColumnFilter",
      //   filterParams: filterParams,
      hide: false,
    },
    {
      field: "type",
      headerName: "Type",
      // valueFormatter: (params) => params.value,
    },
    {
      field: "amount",
      headerName: "Amount",
      // valueFormatter: (params) => {
      //   return parseFloat(params.value).toFixed(2);
      // },
      cellRenderer: (params) => {
        // console.log("The params are : ", params.data.type);
        if (params.data.type === "DEBIT") {
          return currSymbol + " " + parseFloat(params.value).toFixed(2);
        } else {
          return currSymbol + " " + parseFloat(params.value).toFixed(2);
        }
        // const updatedBookingId =
        //   "SFBOOKING_" + String(hotelId) + "_" + String(param.value);
        // return (
        //   <Link
        //     to={{
        //       pathname: `/folio/${updatedBookingId}`,
        //       search: `?hotelId=${hotelId}`,
        //     }}
        //     target="_blank"
        //   >
        //     {param.value}
        //   </Link>
        // );
      },
    },
    { field: "status", headerName: "Status" },
    {
      field: "id",
      headerName: "Invoice Actions",
      colId: "invoiceActions",
      sortable: false,
      minWidth: 250,
      cellClass: "invoice-actions-cell",
      cellStyle: { display: "flex", alignItems: "center" },
      cellRendererFramework: (params) => renderInvoiceActionsCell(params, false),
    },
    {
      field: "id",
      headerName: "Payment",
      colId: "payNowAction",
      sortable: false,
      minWidth: 180,
      cellStyle: { display: "flex", alignItems: "center" },
      cellRendererFramework: (params) => {
        const entry = params?.data;
        if (!isEligibleForPayNow(entry)) {
          return entry?.payment_status === "PAID" ||
            entry?.status === "PAID" ? (
            <Chip label="Paid" color="success" size="small" />
          ) : (
            ""
          );
        }
        const tdsPercent = getTdsPercentage(accountInfo?.account_details);
        const { netPayable } = calculateTdsBifurcation(
          parseFloat(entry?.amount),
          tdsPercent
        );
        return (
          <Button
            variant="contained"
            size="small"
            sx={{
              textTransform: "none",
              bgcolor: "#1ab394",
              "&:hover": { bgcolor: "#158a70" },
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleOpenPayNowModal(entry);
            }}
          >
            Pay Now ({formatCurrency(netPayable, hotelCurr)})
          </Button>
        );
      },
    },
  ];

  // useEffect(() => {
  //   console.log(
  //     "accBalance : ",
  //     accBalance,
  //     " type of accBalance : ",
  //     typeof accBalance
  //   );

  //   if (accBalance) {
  //     console.log("In if block");
  //     let accBal = parseInt(accBalance);
  //     console.log("new accBal pasing : ", accBal);
  //     // debugger;
  //     if (accBal >= 0) {
  //       let flag = true;
  //       columns.map((columnObj) => {
  //         Object.entries(columnObj).map(([key, value]) => {
  //           if (key === "field" && value === "id") flag = false;
  //         });
  //       });
  //       if (flag) {
  //         columns.push({
  //           field: "id",
  //           headerName: "Download Invoice",
  //           sortable: true,
  //           // checkboxSelection: true,
  //           // headerCheckboxSelection: true,
  //           cellRendererFramework: (params) => {
  //             console.log("params?.data?.type : ", params?.data?.type);
  //             if (params?.data?.type === "DEBIT") {
  //               console.log("Inside if of cellrenderer before return");
  //               return (
  //                 <Button
  //                   variant="custom-button"
  //                   style={{
  //                     // fontSize: "16px",
  //                     // cursor: "pointer",
  //                     // color: "#49D0C9",
  //                     // fontWeight: "bold",
  //                     height: "2rem",
  //                   }}
  //                   onClick={() => {
  //                     console.log("Params are : ", params);
  //                     console.log("The id is ", params.value);
  //                     // setCurrentMessage(params.value);
  //                     // onOpenMessageModal();
  //                   }}
  //                 >
  //                   <u>Download</u>
  //                 </Button>
  //               );
  //             }
  //             return "";
  //           },
  //         });
  //       }
  //     }
  //   }
  // }, [accBalance]);

  const defaultColDefs = {
    cellStyle: { fontSize: "9px" },
    sortable: true, //sort the table
    floatingFilter: true, // getting the filter below the columns
    tooltipField: "name",
    filter: "agMultiColumnFilter", // setting the multi column filter for the table
    display: "subMenu", // how the text filter and the set filter will look like
    components: {
      agDateInput: CustomDateComponent,
    },
    resizable: true,
    cellRendererParams: {
      checkbox: true,
    },
    flex: 1,
  };

  function updatePinnedRowonDateChange() {
    let result = [
      {
        date: "Total",
        amount: accBalance,
      },
    ];
    const data = rowsData?.forEach((data) => {
      result[0].amount = accBalance;
    });
    gridApi && gridApi.setPinnedBottomRowData(result);
  }

  const onSelectionChanged = (event) => {
    // console.log("event : ", event);
    setSelectedRowsLength(event.api.getSelectedRows().length);
    setSelectedRows(event.api.getSelectedRows());
    const selectedBooking_Id = event.api.getSelectedRows()[0]?.bookingid;
    setSelectedBookingId(selectedBooking_Id);
    // console.log("Selected rows length", event.api.getSelectedRows().length)
  };

  // console.log("selectedRows : ", selectedRows);
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState(null);
  const [invoiceSet, setInvoiceSet] = useState(null);
  const selectedNonIndiaInvoiceIds = useMemo(
    () => getEligibleNonIndiaInvoiceIds(selectedRows || []),
    [selectedRows]
  );

  useEffect(() => {
    if (selectedRows && selectedRows !== undefined && selectedRows.length > 0) {
      let data = [];
      let seet = new Set();
      const daaata = selectedRows.map((res) => {
        let id;
        let type;
        let mode;
        let invoiceId;
        let invoiceDate;
        let changeDate;
        const dattta = Object.entries(res).map(([key, value]) => {
          if (key === "type") type = value;
          if (key === "serial_invoice_id") invoiceId = value;
          if (key === "mode") mode = value;
          if (key === "invoice_date_epoc") invoiceDate = value;
          if (key === "accounting_version_change_date") changeDate = value;
          if (key === "id") {
            id = value;
          }
        });
        // console.log(type);
        // console.log(id);
        // console.log(mode);
        // console.log(invoiceId);
        // console.log(invoiceDate);
        // console.log(changeDate);
        if (
          type === "DEBIT"
          // &&
          // (mode === "SUBSCRIPTION" || mode === "subscription") &&
          // invoiceId === "" &&
          // changeDate &&
          // changeDate !== 0 &&
          // changeDate < invoiceDate
        ) {
          data.push(id);
          seet.add(id);
        }
      });
      // console.log("Data : ", data);
      setSelectedInvoiceIds(data);
      setInvoiceSet(seet);
    } else {
      setSelectedInvoiceIds(null);
      setInvoiceSet(null);
    }
  }, [selectedRows]);

  // console.log("rowsData : ", rowsData);

  const generateSelectedNonIndiaInvoicesAPI = () => {
    if (!selectedNonIndiaInvoiceIds.length) {
      toast.error(
        "Select at least one DEBIT subscription entry to generate invoices."
      );
      return;
    }

    setgenericLoad(true);
    generateInvoicesForLedgerIds(selectedNonIndiaInvoiceIds)
      .then((res) => {
        toast.success(res || "Invoices generated successfully");
        refreshBillingData();
        handleBulkGenerateInvoicesClose();
        setgenericLoad(false);
      })
      .catch((err) => {
        toast.error(
          getErrorMessage(
            err,
            "Unable to generate invoices. Please try again later."
          )
        );
        handleBulkGenerateInvoicesClose();
        setgenericLoad(false);
      });
  };

  const generateInvoicesAPI = () => {
    if (rowsData && rowsData !== undefined && rowsData.length > 0) {
      let allIds = [];
      const data = rowsData.map((res) => {
        let id;
        let type;
        let mode;
        let invoiceId;
        let invoiceDate;
        let changeDate;
        const dattta = Object.entries(res).map(([key, value]) => {
          if (key === "type") type = value;
          if (key === "serial_invoice_id") invoiceId = value;
          if (key === "mode") mode = value;
          if (key === "invoice_date_epoc") invoiceDate = value;
          if (key === "accounting_version_change_date") changeDate = value;
          if (key === "id") {
            id = value;
          }
        });
        // console.log(type);
        // console.log(id);
        // console.log(mode);
        // console.log(invoiceId);
        // console.log(invoiceDate);
        // console.log(changeDate);
        if (
          type === "DEBIT" &&
          (mode === "SUBSCRIPTION" || mode === "subscription") &&
          invoiceId === "" &&
          changeDate &&
          changeDate !== 0 &&
          changeDate < invoiceDate
        ) {
          allIds.push(id);
        }
      });
      // console.log("all ids : ", allIds);
      if (
        allIds &&
        selectedInvoiceIds &&
        allIds?.length > selectedInvoiceIds.length
      ) {
        // console.log("set is : ", invoiceSet);
        let selIds = selectedInvoiceIds;
        selIds.sort(function (a, b) {
          return a - b;
        });

        // console.log("sorted set ids : ", selIds);
        let leastIdSel = selIds[0];
        let maxIdSel = selIds[selIds.length - 1];

        allIds.sort(function (a, b) {
          return a - b;
        });

        // console.log("sorted all ids : ", allIds);
        // let leastIdAll = allIds[0];
        // let maxIdAll = allIds[selIds.length - 1];

        let flag = false;

        for (let i = 0; i < allIds.length; i++) {
          // debugger;
          // if (invoiceSet.has(id)) {
          //   flag = true;
          // } else if (id > leastId && id < maxId) {
          //   flag = true;
          // } else if (id < leastId) {
          //   flag = false;
          // }

          if (invoiceSet.has(allIds[i])) {
            flag = true;
          } else if (allIds[i] < maxIdSel) {
            flag = false;
            break;
          }
        }

        if (!flag) {
          toast.error(
            "Please void or generate invoice ids for previous invoices first"
          );
          return;
        }
      }
      // else {
      //   toast.success("Length is same");
      //   return;
      // }
      setgenericLoad(true);
      generateInvoicesForLedgerIds(selectedInvoiceIds)
        .then((res) => {
          toast.success(res);
          const data = props?.getLedgerData();
          const datas = props?.getAccountBalance();
          getIndianPaymentMethodDetails();
          fetchPaymentMethodData();
          getNextInvoicingSchedule();
          setSelectedInvoiceIds(null);
          setInvoiceSet(null);
          handleGenerateInvoicesClose();
          setgenericLoad(false);
        })
        .catch((err) => {
          toast.error("Unable to generate invoice ids, Please try again later");
          // console.log(err);
          setSelectedInvoiceIds(null);
          setInvoiceSet(null);
          handleGenerateInvoicesClose();
          setgenericLoad(false);
        });
    }
  };

  const voidInvoicesAPI = () => {
    console.log("in voidInvoicesAPI");
    if (selectedInvoiceIds && selectedInvoiceIds.length > 1) {
      toast.error("Please select only one invoice to void");
      return;
    }
    console.log(selectedInvoiceIds);
    let voidInvoiceId = selectedInvoiceIds;
    console.log(voidInvoiceId[0]);
    setgenericLoad(true);
    handleSpringDataRequest(
      `core/api/v1/account-ledger/void-invoice/${groupId}/${voidInvoiceId[0]}`
    )
      .then((res) => {
        toast.success(res);
        const data = props?.getLedgerData();
        const datas = props?.getAccountBalance();
        getIndianPaymentMethodDetails();
        fetchPaymentMethodData();
        getNextInvoicingSchedule();
        setSelectedInvoiceIds(null);
        setInvoiceSet(null);
        handleVoidInvoicesClose();
        setgenericLoad(false);
      })
      .catch((err) => {
        toast.error("Unable to void invoice, Please try again later");
        setSelectedInvoiceIds(null);
        setInvoiceSet(null);
        handleVoidInvoicesClose();
        setgenericLoad(false);
      });
    // toast.success("the id to void is ", voidInvoiceId);
  };

  const gridOptions = {
    pagination: true,
    onGridColumnsChanged: (params) => {
      //   console.log(
      //     "params : ",
      //     params.columnApi.columnController.displayedColumns
      //   );
    },
    // generation of the pinned bottom row data
    onFilterChanged: (params) => {
      let result = {
        date: "Total",
        amount: accBalance,
      };
      setTimeout(() => {
        params.api.forEachNodeAfterFilter((i) => {
          result.amount = accBalance;
        });
        params.api.setPinnedBottomRowData([result]);
      }, 0);
    },
    rowSelection: "multiple",
  };

  useEffect(() => {
    rowsData && updatePinnedRowonDateChange();
  });

  const onExportClick = () => {
    selectedRowsLength === 0
      ? gridApi.exportDataAsCsv()
      : gridApi.exportDataAsCsv({ onlySelected: true });
  };

  //  Exporting it in the Excel format
  const onExportExcel = () => {
    selectedRowsLength === 0
      ? gridApi.exportDataAsExcel()
      : gridApi.exportDataAsExcel({ onlySelected: true });
  };

  const getDownloadType = (dType) => {
    // console.log("download type", dType);
    dType === "1" && onExportClick();
    // dType === "2" && onOpenModal();
    dType === "3" && onExportExcel();
    // dType === "4" && onExportTally();
  };

  // Getting the number of enteries
  const [numEnteries, setNumEnteries] = useState(0);
  const [selectedNumEnteries, setSelectedNumEnteries] = useState(0);
  useEffect(() => {
    setSelectedNumEnteries(selectedRowsLength);
    setNumEnteries(rowsData?.length);
  }, [rowsData, selectedRowsLength]);

  // different date type fiters eg : checkin date, check out date, etc.
  const [filterDateType, setFilterDateType] = useState("staythrough");
  const onChangeDateFilter = (filterType) => {
    // console.log("date filter type", filterType);
    setFilterDateType(filterType);
  };

  const handleDate = (selectedDate) => {
    return moment(selectedDate).format("YYYY-MM-DD");
  };

  var date = new Date();
  const [datePicker, setDatePicker] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const filterParams = {
    debounceMs: 500,
    suppressAndOrCondition: true,
    comparator: function (filterLocalDateAtMidnight, cellValue) {
      if (cellValue == null) {
        return 0;
      }
      //   console.log(moment(dateParts).format("DD-MM-YYYY"))
      var dateParts = moment(cellValue).format("DD-MM-YYYY");
      const formattedDateParts = dateParts.split("-");
      var year = Number(formattedDateParts[2]);
      var month = Number(formattedDateParts[1]) - 1;
      var day = Number(formattedDateParts[0]);
      var cellDate = new Date(year, month, day);

      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      } else if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      } else {
        return 0;
      }
    },
  };
  var recurringOptions = {
    key: razorpayFinalKey,
    // order_id: orderId,
    // customer_id: customerId,
    recurring: "1",
    handler: function (response) {
      // alert(response.razorpay_payment_id);
      // debugger;
      let payload = {
        group_id: groupId,
        "razorpay-pg-id": response.razorpay_payment_id,
        amount: 0,
        currency: "INR",
      };

      handleSpringDataMutationRequest(
        "POST",
        `core/api/v1/payments/razorpay/fetch-token-for-recurring-payments/?groupId=${groupId}&hotelId=${groupId}`,
        payload
      )
        .then((res) => {
          // console.log(res);
          toast.success("SuccessFully added recurring payment method");
          const data = props?.getLedgerData();
          const datas = props?.getAccountBalance();
          getIndianPaymentMethodDetails();
          fetchPaymentMethodData();
          getNextInvoicingSchedule();
          setname("");
          setemail("");
          setcontact("");
          setauthType("netbanking");
          setbeneName("");
          setaccNumber(0);
          setaccountType("savings");
          setifsc("");
          handleCloseOpenEmandateModal();
          setloading(false);
        })
        .catch((err) => {
          console.log(err);
          toast.error(
            "Error while setting up recurring payment method. Please try again later"
          );
          setname("");
          setemail("");
          setcontact("");
          setauthType("netbanking");
          setbeneName("");
          setaccNumber(0);
          setaccountType("savings");
          setifsc("");
          handleCloseOpenEmandateModal();
          setloading(false);
        });

      // alert(response.razorpay_payment_id);
      // alert(response.razorpay_order_id);
      // alert(response.razorpay_signature);
    },
    notes: {
      account_id: groupId,
    },
    theme: {
      color: "#F37254",
    },
  };

  const invokeRecurringRazorpayModal = () => {
    let rzp1 = new window.Razorpay(recurringOptions);
    rzp1.open();
    rzp1.on("payment.failed", function (response) {
      setErrorShow(true);
      setErrorMessage(response?.error?.description);
      setTimeout(() => {
        setErrorShow(false);
      }, 4000);
    });
  };
  const [loading, setloading] = useState(false);

  const createCustomerAndOrder = () => {
    setloading(true);
    if (name === null || name === undefined || name === "") {
      toast.error("Please enter the name");
      setloading(false);
      return;
    }

    if (email === null || email === undefined || email === "") {
      toast.error("Please enter the email");
      setloading(false);
      return;
    }

    if (
      contact === null ||
      contact === undefined ||
      contact === "" ||
      contact.length > 10
    ) {
      toast.error("Please enter the valid contact number");
      setloading(false);
      return;
    }

    if (beneName === null || beneName === undefined || beneName === "") {
      toast.error("Please enter the beneficiary name");
      setloading(false);
      return;
    }

    if (accNumber === null || accNumber === undefined || accNumber === 0) {
      toast.error("Please enter the account number");
      setloading(false);
      return;
    }

    if (ifsc === null || ifsc === undefined || ifsc === "") {
      toast.error("Please enter the ifsc code");
      setloading(false);
      return;
    }

    let payload = {
      name: name,
      email: email,
      contact: contact,
      auth_type: "netbanking",
      beneficiary_name: beneName,
      account_number: accNumber,
      account_type: accountType,
      ifsc_code: ifsc,
    };

    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/payments/razorpay/create-customer-order-recurring-payments/?groupId=${groupId}&hotelId=${groupId}`,
      payload
    )
      .then((res) => {
        setcustomerId(res?.customer?.id);
        setorderId(res?.order?.id);
        // var recurringOptions = {
        //   key: razorpayFinalKey,
        //   order_id: orderId,
        //   customer_id: customerId,
        recurringOptions["customer_id"] = res?.customer?.id;
        recurringOptions["order_id"] = res?.order?.id;
        // doWork();
        setTimeout(() => {
          invokeRecurringRazorpayModal();
        }, 1000);
        // console.log(res);
      })
      .catch((err) => {
        console.log(err.response.data);
        toast.error("Please enter the valid details and try again");
        setname("");
        setemail("");
        setcontact("");
        setauthType("netbanking");
        setbeneName("");
        setaccNumber(0);
        setaccountType("savings");
        setifsc("");

        handleCloseOpenEmandateModal();
        setloading(false);
      });
  };

  const [state, setState] = useState({ right: false });

  // console.log("pmDetails : ", pmDetails);
  // console.log("nextPaySchedule : ", nextPaySchedule);
  // console.log("hotelCurr : ", hotelCurr);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const getUrl = () => {
    if (process.env.REACT_APP_ENV_PAY === "PROD") {
      return "https://app.stayflexi.com/";
    } else if (process.env.REACT_APP_ENV_PAY === "PREPROD") {
      return "https://preprod-app.stayflexi.com/";
    } else {
      return "https://beta.app.stayflexi.com/";
    }
  };
  const [pendingDays, setpendingDays] = useState(0);
  const [showPendingDays, setshowPendingDays] = useState(false);
  useEffect(() => {
    if (
      groupId !== null &&
      groupId !== undefined &&
      groupId !== "" &&
      hotelCurr === "INR"
    ) {
      handleSpringDataRequest(
        `web-api/get-payment-dues-amount?groupId=${groupId}&hotel_id=${groupId}&hotelId=${groupId}`
      )
        .then((res) => {
          if (res !== null && res !== undefined) {
            if (res.pendingAmount < 0) {
              setshowPendingDays(true);
              setpendingDays(res.daysDiff);
            }
          }
        })
        .catch((err) => console.error(err));
    }
  }, [groupId, hotelCurr]);

  console.log("pendingDays", pendingDays);
  const cardsGetStartMap = {
    visa: "VI...",
    mastercard: "MC...",
    amex: "AX...",
    discover: "DC...",
    "": "AC...",
  };

  const getAllPaymentMethods = () => {
    axios
      .get(
        `${BASE_SPRING_ENDPOINT}` +
          `core/api/v1/account-payment-method/get-all?groupId=${groupId}&hotelId=${groupId}`
      )
      .then((res) => {
        setPaymentMethods(res?.data);
      })
      .catch((err) => {
        console.log("err is : ", err);
      });
  };

  useEffect(() => {
    groupId && getAllPaymentMethods();
  }, [groupId]);

  return (
    <div>
      {rowsData === null ? (
        <ReportsLoader />
      ) : (
        <div>
          {nextPaySchedule &&
            hotelCurr === "INR" &&
            indPaymentMethod === false && (
              <div>
                <Collapse in={banneropen}>
                  <Alert
                    icon={false}
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setBannerOpen(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    sx={{ mb: 2 }}
                  >
                    Your next invoice will be automatically generated on{" "}
                    {moment(
                      nextPaySchedule?.next_schedule_date,
                      "DD/MM/YYYY"
                    ).format("Do MMMM, YYYY")}
                    , covering the period from{" "}
                    {moment(
                      nextPaySchedule?.schedule_start,
                      "DD/MM/YYYY"
                    ).format("Do MMMM, YYYY")}{" "}
                    to{" "}
                    {moment(nextPaySchedule?.schedule_end, "DD/MM/YYYY").format(
                      "Do MMMM, YYYY"
                    )}
                    , for a total of {currSymbol} {nextPaySchedule?.amount}.
                    Please click on add payment method button to enroll for
                    autopay.
                  </Alert>
                </Collapse>
              </div>
            )}

          {nextPaySchedule &&
            hotelCurr === "INR" &&
            indPaymentMethod === true && (
              <div>
                <Collapse in={banneropen}>
                  <Alert
                    icon={false}
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setBannerOpen(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    sx={{ mb: 2 }}
                  >
                    Your next invoice will be automatically generated on{" "}
                    {moment(
                      nextPaySchedule?.next_schedule_date,
                      "DD/MM/YYYY"
                    ).format("Do MMMM, YYYY")}
                    , covering the period from{" "}
                    {moment(
                      nextPaySchedule?.schedule_start,
                      "DD/MM/YYYY"
                    ).format("Do MMMM, YYYY")}{" "}
                    to{" "}
                    {moment(nextPaySchedule?.schedule_end, "DD/MM/YYYY").format(
                      "Do MMMM, YYYY"
                    )}
                    , for a total of {currSymbol} {nextPaySchedule?.amount}.
                    <a
                      onClick={() => {
                        handleindPayOpen();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      <b>
                        <u>Click here</u>
                      </b>{" "}
                    </a>
                    to view subscribed payment method.
                  </Alert>
                </Collapse>
              </div>
            )}

          {nextPaySchedule &&
            hotelCurr !== "INR" &&
            pmDetails &&
            pmDetails !== undefined && (
              <div>
                <Collapse in={banneropen}>
                  <Alert
                    icon={false}
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setBannerOpen(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    sx={{ mb: 2 }}
                  >
                    Your next invoice will be automatically generated on{" "}
                    {moment(
                      nextPaySchedule?.next_schedule_date,
                      "DD/MM/YYYY"
                    ).format("Do MMMM, YYYY")}
                    , covering the period from{" "}
                    {moment(
                      nextPaySchedule?.schedule_start,
                      "DD/MM/YYYY"
                    ).format("Do MMMM, YYYY")}{" "}
                    to{" "}
                    {moment(nextPaySchedule?.schedule_end, "DD/MM/YYYY").format(
                      "Do MMMM, YYYY"
                    )}
                    , for a total of {currSymbol}{nextPaySchedule?.amount}.
                    Visit Payment Methods page to manage subscribed payment
                    method.
                  </Alert>
                </Collapse>
              </div>
            )}

          {nextPaySchedule &&
            hotelCurr !== "INR" &&
            (pmDetails === null || pmDetails === undefined) && (
              <div>
                <Collapse in={banneropen}>
                  <Alert
                    icon={false}
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setBannerOpen(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    sx={{ mb: 2 }}
                  >
                    Your next invoice will be automatically generated on{" "}
                    {moment(
                      nextPaySchedule?.next_schedule_date,
                      "DD/MM/YYYY"
                    ).format("Do MMMM, YYYY")}
                    , covering the period from{" "}
                    {moment(
                      nextPaySchedule?.schedule_start,
                      "DD/MM/YYYY"
                    ).format("Do MMMM, YYYY")}{" "}
                    to{" "}
                    {moment(nextPaySchedule?.schedule_end, "DD/MM/YYYY").format(
                      "Do MMMM, YYYY"
                    )}
                    , for a total of {currSymbol} {nextPaySchedule?.amount}.
                    Please add a payment method to enroll for autopay.
                  </Alert>
                </Collapse>
              </div>
            )}

          <div
            style={{
              display: "flex",

              justifyContent: "end",
            }}
          >
            <div className="d-flex flex-column">
              {accBalance && (
                <Typography
                  variant="h6"
                  style={{ fontWeight: "400", marginBottom: "1rem" }}
                >
                  Current Outstanding : {currSymbol + " " + accBalance}
                </Typography>
              )}
              {hotelCurr === "INR" && showPendingDays && (
                <Typography
                  variant="h6"
                  style={{ fontWeight: "400", marginBottom: "1rem" }}
                >
                  Pending from : {pendingDays} days
                </Typography>
              )}
            </div>
          </div>

          <div>
            <Stack className="agGridWrapr position-relative">
              <Stack
                spacing={2}
                className="agGridTableWrapper position-relative w-100"
              >
                <Stack
                  direction="row"
                  className="position-relative w-100 justify-content-between"
                >
                  <Stack direction="row" spacing={2}>
                    <TextField
                      id="outlined-basic"
                      onChange={onFilterTextChange}
                      label="Search"
                      size="small"
                    />
                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">
                          Pages
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={gridApi?.paginationPageSize}
                          label="Pages"
                          onChange={(e) => onPaginationChange(e.target.value)}
                        >
                          <MenuItem value={"10"}>10</MenuItem>
                          <MenuItem value={"20"}>20</MenuItem>
                          <MenuItem value={"50"}>50</MenuItem>
                          <MenuItem value={"100"}>100</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>

                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">
                          Export as
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={"0"}
                          label="Export as"
                          onChange={(e) => getDownloadType(e.target.value)}
                        >
                          <MenuItem value={"0"}>Select option</MenuItem>
                          <MenuItem value={"1"}>Export as CSV</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                    {(!accountInfo?.accounting_version ||
                      accountInfo?.accounting_version === 1) && (
                      <Button
                        variant="custom-button"
                        style={{
                          fontWeight: "400",
                          marginLeft: "2rem",
                          marginBottom: "1rem",
                          marginTop: "4px",
                          height: "2rem",
                        }}
                        onClick={() => {
                          handleOpenAccountingVersionModalOpen();
                        }}
                      >
                        Change accounting version
                      </Button>
                    )}
                    {(nextPaySchedule === null ||
                      nextPaySchedule === undefined) && (
                      <Button
                        variant="custom-button"
                        style={{
                          fontWeight: "400",
                          marginLeft: "2rem",
                          marginBottom: "1rem",
                          marginTop: "4px",
                          height: "2rem",
                        }}
                        onClick={() => {
                          handleOpenCreateBillingSchedule();
                        }}
                      >
                        Create billing schedule
                      </Button>
                    )}
                    {nextPaySchedule && (
                      <Button
                        variant="custom-button"
                        style={{
                          fontWeight: "400",
                          marginLeft: "2rem",
                          marginBottom: "1rem",
                          marginTop: "4px",
                          height: "2rem",
                        }}
                        onClick={() => {
                          handleOpenDeleteBillingSchedule();
                        }}
                      >
                        Delete billing schedule
                      </Button>
                    )}
                    <Button
                      variant="custom-button"
                      style={{
                        fontWeight: "400",
                        marginLeft: "2rem",
                        marginBottom: "1rem",
                        marginTop: "4px",
                        height: "2rem",
                      }}
                      onClick={() => {
                        handleOpenCreateManualEntry();
                      }}
                    >
                      Add manual ledger entry
                    </Button>

                    {hotelCurr && hotelCurr !== "INR" && (
                      <Button
                        variant="custom-button"
                        style={{
                          fontWeight: "400",
                          marginLeft: "2rem",
                          marginBottom: "1rem",
                          marginTop: "4px",
                          height: "2rem",
                        }}
                        disabled={
                          genericLoad || selectedNonIndiaInvoiceIds.length === 0
                        }
                        onClick={() => {
                          handleOpenBulkGenerateInvoices();
                        }}
                      >
                        Generate invoices
                      </Button>
                    )}

                    {hotelCurr && hotelCurr === "INR" && (
                      <Button
                        variant="custom-button"
                        style={{
                          fontWeight: "400",
                          marginLeft: "2rem",
                          marginBottom: "1rem",
                          marginTop: "4px",
                          height: "2rem",
                        }}
                        onClick={() => {
                          handleOpenGenerateInvoices();
                        }}
                      >
                        Generate invoices
                      </Button>
                    )}

                    {hotelCurr && hotelCurr === "INR" && (
                      <Button
                        variant="custom-button"
                        style={{
                          fontWeight: "400",
                          marginLeft: "2rem",
                          marginBottom: "1rem",
                          marginTop: "4px",
                          height: "2rem",
                        }}
                        onClick={() => {
                          handleOpenVoidInvoices();
                        }}
                      >
                        Void invoice
                      </Button>
                    )}

                    {hotelCurr && hotelCurr === "INR" && (
                      <Button
                        variant="custom-button"
                        style={{
                          fontWeight: "400",
                          marginLeft: "2rem",
                          marginBottom: "1rem",
                          marginTop: "4px",
                          height: "2rem",
                        }}
                        onClick={() => {
                          handleOpenshowPaymentLink();
                        }}
                      >
                        Copy payment link
                      </Button>
                    )}
                  </Stack>
                </Stack>
                {rowsData && hotelCurr && hotelCurr === "INR" ? (
                  <Stack className="agTable">
                    <Stack className="ag-theme-material" sx={{ height: 800 }}>
                      <AgGridReact
                        className="agGridTable"
                        rowData={rowsData}
                        onGridReady={onGridReady}
                        columnDefs={columnsInr}
                        defaultColDef={defaultColDefs}
                        enableBrowserTooltips={true}
                        onSelectionChanged={onSelectionChanged}
                        enableMultiRowDragging={false}
                        rowMultiSelectWithClick={false}
                        paginationPageSize={50}
                        alwaysShowBothConditions={true}
                        rowSelection={rowSelectionType}
                        suppressPivotMode={true}
                        suppressColumnMove={true}
                        suppressRowGroups={true}
                        sideBar={sideBar()}
                        groupMultiAutoColumn={true}
                        statusBar={{
                          statusPanels: [
                            {
                              statusPanel:
                                "agTotalAndFilteredRowCountComponent",
                              align: "left",
                            },
                            {
                              statusPanel: "agTotalRowCountComponent",
                              align: "center",
                            },
                            { statusPanel: "agFilteredRowCountComponent" },
                            { statusPanel: "agSelectedRowCountComponent" },
                            { statusPanel: "agAggregationComponent" },
                          ],
                        }}
                        gridOptions={gridOptions}
                      />
                    </Stack>
                  </Stack>
                ) : (
                  <Stack className="agTable">
                    <Stack className="ag-theme-material" sx={{ height: 800 }}>
                      <AgGridReact
                        className="agGridTable"
                        rowData={rowsData}
                        onGridReady={onGridReady}
                        columnDefs={columnsUsd}
                        defaultColDef={defaultColDefs}
                        enableBrowserTooltips={true}
                        onSelectionChanged={onSelectionChanged}
                        enableMultiRowDragging={false}
                        rowMultiSelectWithClick={false}
                        paginationPageSize={50}
                        alwaysShowBothConditions={true}
                        rowSelection={rowSelectionType}
                        suppressPivotMode={true}
                        suppressColumnMove={true}
                        suppressRowGroups={true}
                        sideBar={sideBar()}
                        groupMultiAutoColumn={true}
                        statusBar={{
                          statusPanels: [
                            {
                              statusPanel:
                                "agTotalAndFilteredRowCountComponent",
                              align: "left",
                            },
                            {
                              statusPanel: "agTotalRowCountComponent",
                              align: "center",
                            },
                            { statusPanel: "agFilteredRowCountComponent" },
                            { statusPanel: "agSelectedRowCountComponent" },
                            { statusPanel: "agAggregationComponent" },
                          ],
                        }}
                        gridOptions={gridOptions}
                      />
                    </Stack>
                  </Stack>
                )}
              </Stack>
            </Stack>
          </div>
        </div>
      )}
      <Modal
        open={openindPay}
        onClose={handleindPayClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Payment method details</div>
              <div className="close" onClick={() => handleindPayClose()}>
                X
              </div>
            </div>
            <div className="amountWrapper">
              {indPaymentDetail && (
                <div className="fieldWrapper">
                  <div style={{ display: "flex" }}>
                    <p style={{ marginRight: "1rem" }}>Payment method type</p>
                    <p>-</p>
                    <p style={{ marginLeft: "1rem" }}>Net-Banking</p>
                  </div>

                  {/* <div style={{ display: "flex" }}>
                    <p style={{ marginRight: "1rem" }}>Account name</p>
                    <p>-</p>
                    <p style={{ marginLeft: "1rem" }}>
                      {indPaymentDetail?.payment_method}
                    </p>
                  </div> */}

                  <div style={{ display: "flex" }}>
                    <p style={{ marginRight: "1rem" }}>Account last 4</p>
                    <p>-</p>
                    <p style={{ marginLeft: "1rem" }}>
                      {indPaymentDetail?.bank_last4}
                    </p>
                  </div>
                </div>
              )}
              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => handleindPayClose()}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Confirm the details</div>
              <div className="close" onClick={() => handleClose()}>
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <TextField
                  required
                  id="outlined-name"
                  label="Enter the amount"
                  name="deposit_amount"
                  value={depositAmt}
                  onChange={(e) =>
                    /^[0-9.]*$/.test(e.target.value)
                      ? setDepositAmt(e.target.value)
                      : setDepositAmt(depositAmt)
                  }
                  sx={{ width: "100%" }}
                  type={"text"}
                />
              </div>

              {pmDetails && (
                <div className="fieldWrapper">
                  <Typography
                    variant="h5"
                    style={{ fontWeight: "600", marginBottom: "1rem" }}
                  >
                    Payment method details
                  </Typography>
                  {pmDetails?.payment_method_type === "account" ? (
                    <div style={{ display: "flex" }}>
                      <p style={{ marginRight: "1rem" }}>Payment method type</p>
                      <p>-</p>
                      <p style={{ marginLeft: "1rem" }}>Account</p>
                    </div>
                  ) : (
                    <div style={{ display: "flex" }}>
                      <p style={{ marginRight: "1rem" }}>Payment method type</p>
                      <p>-</p>
                      <p style={{ marginLeft: "1rem" }}>
                        {pmDetails?.card_type === "credit"
                          ? "Credit card"
                          : "Debit card"}
                      </p>
                    </div>
                  )}
                  {pmDetails?.payment_method_type === "account" ? (
                    <div style={{ display: "flex" }}>
                      <p style={{ marginRight: "1rem" }}>Account last 4</p>
                      <p>-</p>
                      <p style={{ marginLeft: "1rem" }}>
                        {pmDetails?.ach_account_last4}
                      </p>
                    </div>
                  ) : (
                    <div style={{ display: "flex" }}>
                      <p style={{ marginRight: "1rem" }}>Card last 4</p>
                      <p>-</p>
                      <p style={{ marginLeft: "1rem" }}>
                        {pmDetails?.card_last4}
                      </p>
                    </div>
                  )}

                  {pmDetails?.payment_method_type === "account" ? (
                    <div style={{ display: "flex" }}>
                      <p style={{ marginRight: "1rem" }}>Account type</p>
                      <p>-</p>
                      <p style={{ marginLeft: "1rem" }}>
                        {pmDetails?.ach_account_type}
                      </p>
                    </div>
                  ) : (
                    <div style={{ display: "flex" }}>
                      <p style={{ marginRight: "1rem" }}>Card issuer</p>
                      <p>-</p>
                      <p style={{ marginLeft: "1rem" }}>
                        {pmDetails?.card_issuer.toUpperCase()}
                      </p>
                    </div>
                  )}
                </div>
              )}
              <div className="settleDuesSubmitBtns">
                <Button className="cancelBtn" onClick={() => handleClose()}>
                  Cancel
                </Button>
                <Button
                  variant="custom-button"
                  onClick={handleFortisPayment}
                  disabled={depositLoading || depositAmt <= 0}
                >
                  {depositLoading ? (
                    <CircularProgress
                      size={15}
                      color="inherit"
                      sx={{ ml: 1.5 }}
                    />
                  ) : (
                    "Pay"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openDInvoice}
        onClose={handleCloseDInvoice}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Download invoice</div>
              <div className="close" onClick={() => handleCloseDInvoice()}>
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <Typography>Do you want to download the invoice</Typography>
              </div>

              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => handleCloseDInvoice()}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={load}
                  onClick={() => downloadInvoice(currentLedgerId)}
                >
                  {load ? (
                    <CircularProgress
                      size={15}
                      color="inherit"
                      sx={{ ml: 1.5 }}
                    />
                  ) : (
                    "Download"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openAmountModal}
        onClose={handleAmountClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Confirm the details</div>
              <div className="close" onClick={() => handleAmountClose()}>
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <TextField
                  required
                  id="outlined-name"
                  label="Enter the amount"
                  name="deposit_amount"
                  value={razorpayAmount}
                  onChange={(e) => {
                    /^[0-9.]*$/.test(e.target.value)
                      ? setRazorpayAmount(e.target.value)
                      : setRazorpayAmount(razorpayAmount);
                  }}
                  sx={{ width: "100%" }}
                  type={"text"}
                />
              </div>

              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => handleAmountClose()}
                >
                  Cancel
                </Button>
                <Button
                  variant="custom-button"
                  onClick={() => {
                    handleAmountClose();
                    let amt = razorpayAmount.toString().split(".");
                    let final = amt[0];
                    options["amount"] = final * 100 + "";

                    setRazorpayAmount(final * 100 + "");
                    invokeRazorpayModal();
                  }}
                  disabled={razorpayAmount <= 0}
                >
                  Pay
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openEmandateModal}
        onClose={handleCloseOpenEmandateModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Enter the details</div>
              <div
                className="close"
                onClick={() => {
                  setloading(false);
                  handleCloseOpenEmandateModal();
                }}
              >
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <TextField
                  size="small"
                  required
                  id="outlined-name"
                  label="Enter name"
                  name="deposit_amount"
                  value={name}
                  onChange={(e) => {
                    setname(e.target.value);
                  }}
                  sx={{ width: "100%" }}
                  type={"text"}
                />
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <TextField
                  size="small"
                  required
                  id="outlined-name"
                  label="Enter email"
                  name="deposit_amount"
                  value={email}
                  onChange={(e) => {
                    setemail(e.target.value);
                  }}
                  sx={{ width: "100%" }}
                  type={"text"}
                />
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <TextField
                  size="small"
                  required
                  id="outlined-name"
                  label="Enter contact number"
                  name="deposit_amount"
                  value={contact}
                  onChange={(e) => {
                    /^[0-9.]*$/.test(e.target.value)
                      ? setcontact(e.target.value)
                      : setcontact(contact);
                  }}
                  sx={{ width: "100%" }}
                  type={"text"}
                />
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <TextField
                  size="small"
                  required
                  id="outlined-name"
                  label="Enter beneficiary name"
                  name="deposit_amount"
                  value={beneName}
                  onChange={(e) => {
                    setbeneName(e.target.value);
                  }}
                  sx={{ width: "100%" }}
                  type={"text"}
                />
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <TextField
                  size="small"
                  required
                  id="outlined-name"
                  label="Enter account number"
                  name="deposit_amount"
                  value={accNumber}
                  onChange={(e) => {
                    /^[0-9.]*$/.test(e.target.value)
                      ? setaccNumber(e.target.value)
                      : setaccNumber(accNumber);
                  }}
                  sx={{ width: "100%" }}
                  type={"text"}
                />
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <FormControl
                  fullWidth
                  sx={{ width: "12rem", marginRight: "0.5rem" }}
                >
                  <InputLabel id="demo-simple-select-label">
                    Account type
                  </InputLabel>
                  <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={accountType}
                    onChange={(e) => {
                      setaccountType(e.target.value);
                    }}
                    label="Account type"
                  >
                    <MenuItem value={"savings"}>Savings</MenuItem>
                    <MenuItem value={"current"}>Current</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <TextField
                  size="small"
                  required
                  id="outlined-name"
                  label="Enter ifsc"
                  name="deposit_amount"
                  value={ifsc}
                  onChange={(e) => {
                    setifsc(e.target.value);
                  }}
                  sx={{ width: "100%" }}
                  type={"text"}
                />
              </div>

              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => {
                    setloading(false);
                    handleCloseOpenEmandateModal();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="custom-button"
                  onClick={() => {
                    createCustomerAndOrder();
                  }}
                >
                  {loading ? (
                    <CircularProgress
                      size={15}
                      color="inherit"
                      sx={{ ml: 1.5 }}
                    />
                  ) : (
                    "Submit"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={openAccountingVersionModal}
        onClose={handleOpenAccountingVersionModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Change accounting version</div>
              <div
                className="close"
                onClick={() => handleOpenAccountingVersionModalClose()}
              >
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <Typography>
                  Do you want to change accounting version to V2?
                </Typography>
              </div>

              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => handleOpenAccountingVersionModalClose()}
                >
                  Cancel
                </Button>
                <Button
                  variant="custom-button"
                  onClick={() => {
                    changeAccountingVersion();
                  }}
                >
                  {genericLoad ? (
                    <CircularProgress
                      size={15}
                      color="inherit"
                      sx={{ ml: 1.5 }}
                    />
                  ) : (
                    "Confirm"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={createBillingSchedule}
        onClose={handleCreateBillingScheduleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Create billing schedule</div>
              <div
                className="close"
                onClick={() => handleCreateBillingScheduleClose()}
              >
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <Typography>Billing start date</Typography>
                <div className="datePicker">
                  <TextField
                    className="mt-3"
                    style={{ width: "20rem" }}
                    type="date"
                    id="outlined-basic"
                    label="Billing start date *"
                    variant="outlined"
                    size="small"
                    value={pickDate}
                    onChange={handlePickDateChange}
                  />
                  {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      size="small"
                      label="Billing start date"
                      inputFormat="dd/MM/yyyy"
                      value={pickDate}
                      onChange={handlePickDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          id="outlined-basic"
                          className="mt-3"
                          style={{ width: "20rem" }}
                          size="small"
                        />
                      )}
                    />
                  </LocalizationProvider> */}
                </div>
                {dayError && (
                  <p style={{ fontSize: "15px", color: "red" }}>
                    The billing schedule can only start from 1st day of month
                  </p>
                )}
              </div>

              <FormControl style={{ marginTop: "10px" }}>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Billing type
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={terminalId}
                  onChange={(e) => setterminalId(e.target.value)}
                >
                  <FormControlLabel
                    value="PRE"
                    control={<Radio />}
                    label="Pre"
                  />
                  <FormControlLabel
                    value="POST"
                    control={<Radio />}
                    label="Post"
                  />
                </RadioGroup>
              </FormControl>

              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => handleCreateBillingScheduleClose()}
                >
                  Cancel
                </Button>
                <Button
                  variant="custom-button"
                  onClick={() => {
                    createBillingScheduleAPI();
                  }}
                >
                  {genericLoad ? (
                    <CircularProgress
                      size={15}
                      color="inherit"
                      sx={{ ml: 1.5 }}
                    />
                  ) : (
                    "Create"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={deleteBillingSchedule}
        onClose={handleDeleteBillingScheduleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Delete billing schedule</div>
              <div
                className="close"
                onClick={() => handleDeleteBillingScheduleClose()}
              >
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <Typography>
                  Do you want to delete the billing schedule for account?
                </Typography>
              </div>

              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => handleDeleteBillingScheduleClose()}
                >
                  Cancel
                </Button>
                <Button
                  variant="custom-button"
                  onClick={() => {
                    deleteBillingScheduleAPI();
                  }}
                >
                  {genericLoad ? (
                    <CircularProgress
                      size={15}
                      color="inherit"
                      sx={{ ml: 1.5 }}
                    />
                  ) : (
                    "Confirm"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={bulkGenerateInvoices}
        onClose={handleBulkGenerateInvoicesClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Generate invoices</div>
              <div
                className="close"
                onClick={() => handleBulkGenerateInvoicesClose()}
              >
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <Typography>
                  Do you want to generate invoices for the selected ledger
                  entries?
                </Typography>

                {selectedNonIndiaInvoiceIds.length > 0 && (
                  <div
                    className="selectedRoomIdsChip"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "flex-start",
                      marginTop: "1rem",
                    }}
                  >
                    <div
                      className="selectedRoomIds"
                      style={{
                        marginTop: "auto",
                        marginBottom: "auto",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                      }}
                    >
                      {selectedNonIndiaInvoiceIds.map((item) => (
                        <div
                          key={item}
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                          }}
                        >
                          <Chip label={item} onClick={() => {}} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => handleBulkGenerateInvoicesClose()}
                >
                  Cancel
                </Button>
                <Button
                  variant="custom-button"
                  disabled={genericLoad || selectedNonIndiaInvoiceIds.length === 0}
                  onClick={() => {
                    generateSelectedNonIndiaInvoicesAPI();
                  }}
                >
                  {genericLoad ? (
                    <CircularProgress
                      size={15}
                      color="inherit"
                      sx={{ ml: 1.5 }}
                    />
                  ) : (
                    "Generate"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={generateInvoices}
        onClose={handleGenerateInvoicesClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Generate invoices</div>
              <div
                className="close"
                onClick={() => handleGenerateInvoicesClose()}
              >
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <Typography>
                  Do you want to generate invoices for below selected invoices?
                </Typography>

                {selectedInvoiceIds && selectedInvoiceIds?.length > 0 && (
                  <div
                    className="selectedRoomIdsChip"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "flex-start",
                      marginTop: "1rem",
                    }}
                  >
                    <div
                      className="selectedRoomIds"
                      style={{
                        marginTop: "auto",
                        marginBottom: "auto",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                      }}
                    >
                      {selectedInvoiceIds.map((item) => (
                        <div
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                          }}
                        >
                          <Chip label={item} onClick={() => {}} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => handleGenerateInvoicesClose()}
                >
                  Cancel
                </Button>
                {selectedInvoiceIds && selectedInvoiceIds?.length > 0 && (
                  <Button
                    variant="custom-button"
                    onClick={() => {
                      generateInvoicesAPI();
                    }}
                  >
                    {genericLoad ? (
                      <CircularProgress
                        size={15}
                        color="inherit"
                        sx={{ ml: 1.5 }}
                      />
                    ) : (
                      "Generate"
                    )}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={voidInvoices}
        onClose={handleVoidInvoicesClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Void invoices</div>
              <div className="close" onClick={() => handleVoidInvoicesClose()}>
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <Typography>
                  Do you want to void below selected invoice?
                </Typography>

                {selectedInvoiceIds && selectedInvoiceIds?.length > 0 && (
                  <div
                    className="selectedRoomIdsChip"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "flex-start",
                      marginTop: "1rem",
                    }}
                  >
                    <div
                      className="selectedRoomIds"
                      style={{
                        marginTop: "auto",
                        marginBottom: "auto",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                      }}
                    >
                      {selectedInvoiceIds.map((item) => (
                        <div
                          style={{
                            marginLeft: "5px",
                            position: "relative",
                            width: "100%",
                            display: "flex",
                            flexWrap: "wrap",
                          }}
                        >
                          <Chip label={item} onClick={() => {}} />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => handleVoidInvoicesClose()}
                >
                  Cancel
                </Button>
                {selectedInvoiceIds && selectedInvoiceIds?.length > 0 && (
                  <Button
                    variant="custom-button"
                    onClick={() => {
                      voidInvoicesAPI();
                    }}
                  >
                    {genericLoad ? (
                      <CircularProgress
                        size={15}
                        color="inherit"
                        sx={{ ml: 1.5 }}
                      />
                    ) : (
                      "Void"
                    )}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={createManualEntry}
        onClose={handleCreateManualEntryClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">
                <Typography variant="h6">Create entry</Typography>
              </div>
              <div
                className="close"
                onClick={() => handleCreateManualEntryClose()}
              >
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <Typography variant="h6">Amount</Typography>{" "}
                <OutlinedInput
                  notched={false}
                  // disabled={true}
                  size="small"
                  label="hello"
                  className="mt-3"
                  fullWidth
                  value={mAmount}
                  onChange={(e) =>
                    /^[0-9.]*$/.test(e.target.value)
                      ? setMAmount(e.target.value)
                      : setMAmount(mAmount)
                  }
                />
                {/* TDS Bifurcation Display for DEBIT entries */}
                {mType === "DEBIT" &&
                  mAmount &&
                  parseFloat(mAmount) > 0 &&
                  isTdsEnabled(accountInfo?.account_details) && (
                    <Box
                      sx={{
                        mt: 2,
                        p: 2,
                        bgcolor: "#f5f5f5",
                        borderRadius: 1,
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ mb: 1, fontWeight: 600 }}
                      >
                        TDS Bifurcation (TDS @{" "}
                        {getTdsPercentage(accountInfo?.account_details)}%)
                      </Typography>
                      {(() => {
                        const bifurcation = calculateTdsBifurcation(
                          parseFloat(mAmount),
                          getTdsPercentage(accountInfo?.account_details)
                        );
                        return (
                          <Stack spacing={0.5}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography variant="body2">
                                Gross Amount:
                              </Typography>
                              <Typography variant="body2">
                                {formatCurrency(
                                  bifurcation.grossAmount,
                                  hotelCurr
                                )}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography variant="body2" color="error">
                                TDS Deduction ({bifurcation.tdsPercentage}%):
                              </Typography>
                              <Typography variant="body2" color="error">
                                -{" "}
                                {formatCurrency(
                                  bifurcation.tdsAmount,
                                  hotelCurr
                                )}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                pt: 1,
                                borderTop: "1px solid #ccc",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 600 }}
                              >
                                Net Payable:
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 600, color: "#1ab394" }}
                              >
                                {formatCurrency(
                                  bifurcation.netPayable,
                                  hotelCurr
                                )}
                              </Typography>
                            </Box>
                          </Stack>
                        );
                      })()}
                    </Box>
                  )}
                <Typography className="mt-3" variant="body2">
                  Quick month range - Will autoset dates below
                </Typography>
                <Stack
                  direction="row"
                  spacing={1}
                  className="mt-2 mb-2"
                  sx={{ flexWrap: "wrap", gap: 1 }}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={genericLoad}
                    onClick={() => applyCreateMonthShortcut(-1)}
                  >
                    Previous month
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={genericLoad}
                    onClick={() => applyCreateMonthShortcut(0)}
                  >
                    Current month
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={genericLoad}
                    onClick={() => applyCreateMonthShortcut(1)}
                  >
                    Next month
                  </Button>
                </Stack>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  className="mt-2"
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">Start date</Typography>
                    <FormControl fullWidth className="mt-1">
                      <TextField
                        type="date"
                        size="small"
                        fullWidth
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </FormControl>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">End date</Typography>
                    <FormControl fullWidth className="mt-1">
                      <TextField
                        type="date"
                        size="small"
                        fullWidth
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </FormControl>
                  </Box>
                </Stack>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  className="mt-4 mb-1"
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">Type</Typography>
                    <FormControl fullWidth className="mt-1">
                      <Select
                        notched={false}
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={mType}
                        label="Type"
                        onChange={(e) => {
                          setMType(e.target.value);
                        }}
                        size="small"
                      >
                        <MenuItem value="DEBIT">DEBIT</MenuItem>
                        <MenuItem value="CREDIT">CREDIT</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">Mode</Typography>
                    <FormControl fullWidth className="mt-1">
                      <Select
                        notched={false}
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={mMode}
                        label="Mode"
                        onChange={(e) => {
                          setMMode(e.target.value);
                        }}
                        size="small"
                      >
                        <MenuItem value="SUBSCRIPTION">SUBSCRIPTION</MenuItem>
                        <MenuItem value="WITHHOLD">WITHHOLD</MenuItem>
                        <MenuItem value="REFUND">REFUND</MenuItem>
                        <MenuItem value="DISCOUNT">DISCOUNT</MenuItem>
                        <MenuItem value="OTHER">OTHER</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Stack>
                {mType === "CREDIT" && (
                  <>
                    {manualPaymentMethods?.length > 1 && (
                      <>
                        <Typography className="mt-4" variant="h6">
                          Payment method
                        </Typography>{" "}
                        <FormControl fullWidth className="mt-3 mb-3">
                          <Select
                            notched={false}
                            labelId="manual-credit-payment-method-label"
                            id="manual-credit-payment-method"
                            value={selectedManualPaymentMethodId}
                            label="Payment method"
                            onChange={(e) => {
                              setSelectedManualPaymentMethodId(
                                String(e.target.value)
                              );
                            }}
                            size="small"
                            disabled={manualPaymentMethodLoading}
                          >
                            {manualPaymentMethods?.map((paymentMethod) => (
                              <MenuItem
                                key={paymentMethod?.id}
                                value={String(paymentMethod?.id)}
                              >
                                {getManualPaymentMethodLabel(paymentMethod)}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </>
                    )}
                    <Typography className="mt-4" variant="h6">
                      Payment method
                    </Typography>{" "}
                    <FormControl fullWidth className="mt-3 mb-3">
                      <Select
                        notched={false}
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={selectedPaymentMethod}
                        label="Payment method"
                        onChange={(e) => {
                          setSelectedPaymentMethod(e.target.value);
                        }}
                        size="small"
                      >
                        {paymentMethods.map((item) => (
                          <MenuItem value={item}>
                            {cardsGetStartMap[item?.card_issuer] +
                              (item?.ach_account_last4 || item?.card_last4)}
                          </MenuItem>
                        ))}
                        <MenuItem value={"defaultMethod"}>Default</MenuItem>
                      </Select>
                    </FormControl>
                  </>
                )}
                {mType === "CREDIT" && (
                  <>
                    <Typography className="mt-4" variant="h6">
                      Source
                    </Typography>{" "}
                    <FormControl fullWidth className="mt-3 mb-3">
                      <Select
                        notched={false}
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={source}
                        label="Mode"
                        onChange={(e) => {
                          setSource(e.target.value);
                        }}
                        size="small"
                      >
                        <MenuItem value="PAYMENT_LINK">Payment Link</MenuItem>
                        <MenuItem value="BANK_TRANSFER">Bank Transfer</MenuItem>
                        <MenuItem value="CHEQUE">Cheque</MenuItem>
                        <MenuItem value="UPI">UPI</MenuItem>
                        <MenuItem value="OTHER">OTHER</MenuItem>
                      </Select>
                    </FormControl>
                  </>
                )}
                <Typography className="mb-1" variant="h6">
                  Description
                </Typography>
                <FormControl fullWidth className="mt-1">
                  <OutlinedInput
                    notched={false}
                    id="outlined-basic"
                    name="aboutUsFullText"
                    label="Description"
                    multiline
                    rows={3}
                    maxRows={25}
                    variant="outlined"
                    value={mDescription}
                    onChange={(e) => {
                      setMDescription(e.target.value);
                    }}
                    type="text"
                  />
                </FormControl>
                {mType &&
                  mMode &&
                  mType === "CREDIT" &&
                  (mMode === "SUBSCRIPTION" || mMode === "OTHER") &&
                  selectedPaymentMethod === "defaultMethod" && (
                    <FormControlLabel
                      className="mt-3"
                      control={
                        <Checkbox
                          checked={charge}
                          onChange={handleCheckboxChecked}
                        />
                      }
                      label="Charge selected payment method"
                    />
                  )}
                <FormControlLabel
                  className="mt-3"
                  control={
                    <Checkbox
                      checked={sendEmail}
                      onChange={handleSendEmailCheckboxChecked}
                    />
                  }
                  label="Send notification email to customer"
                />
                {showManualGenerateInvoiceCheckbox && (
                  <FormControlLabel
                    className="mt-1"
                    control={
                      <Checkbox
                        checked={generateInvoiceOnCreate}
                        onChange={handleGenerateInvoiceOnCreateChange}
                      />
                    }
                    label="Generate Invoice"
                  />
                )}
              </div>

              <div className="settleDuesSubmitBtns">
                <Button
                  className="cancelBtn"
                  onClick={() => handleCreateManualEntryClose()}
                >
                  Cancel
                </Button>
                <Button
                  variant="custom-button"
                  onClick={() => {
                    createManualEntryAPI();
                  }}
                  style={{ width: "8rem", fontSize: "15px" }}
                >
                  {genericLoad ? (
                    <CircularProgress
                      size={15}
                      color="inherit"
                      sx={{ ml: 1.5 }}
                    />
                  ) : (
                    "Create"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal
        open={updateEntry}
        onClose={handleUpdateEnryClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Update ledger entry</div>
              <div className="close" onClick={() => handleUpdateEnryClose()}>
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <Typography variant="h6">Amount</Typography>{" "}
                <OutlinedInput
                  notched={false}
                  size="small"
                  label="hello"
                  className="mt-3"
                  fullWidth
                  value={uAmount}
                  disabled={genericLoad}
                  onChange={(e) =>
                    /^[0-9.]*$/.test(e.target.value)
                      ? setUAmount(e.target.value)
                      : setUAmount(uAmount)
                  }
                />
                <Typography className="mt-3" variant="body2">
                  Quick month range - Will autoset dates below
                </Typography>
                <Stack
                  direction="row"
                  spacing={1}
                  className="mt-2 mb-2"
                  sx={{ flexWrap: "wrap", gap: 1 }}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={genericLoad}
                    onClick={() => applyMonthShortcut(-1)}
                  >
                    Previous month
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={genericLoad}
                    onClick={() => applyMonthShortcut(0)}
                  >
                    Current month
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={genericLoad}
                    onClick={() => applyMonthShortcut(1)}
                  >
                    Next month
                  </Button>
                </Stack>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  className="mt-2"
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">Start date</Typography>
                    <FormControl fullWidth className="mt-1">
                      <TextField
                        type="date"
                        size="small"
                        fullWidth
                        value={startDateUpdate}
                        onChange={(e) => {
                          setStartDateUpdate(e.target.value);
                        }}
                      />
                    </FormControl>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">End date</Typography>
                    <FormControl fullWidth className="mt-1">
                      <TextField
                        type="date"
                        size="small"
                        fullWidth
                        value={endDateUpdate}
                        onChange={(e) => setEndDateUpdate(e.target.value)}
                      />
                    </FormControl>
                  </Box>
                </Stack>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  className="mt-4 mb-1"
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">Type</Typography>
                    <FormControl fullWidth className="mt-1">
                      <Select
                        disabled={genericLoad}
                        notched={false}
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={uType}
                        label="Type"
                        onChange={(e) => {
                          setUType(e.target.value);
                        }}
                        size="small"
                      >
                        <MenuItem value="DEBIT">DEBIT</MenuItem>
                        <MenuItem value="CREDIT">CREDIT</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h6">Mode</Typography>
                    <FormControl fullWidth className="mt-1 mb-3">
                      <Select
                        disabled={genericLoad}
                        notched={false}
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={uMode}
                        label="Mode"
                        onChange={(e) => {
                          setUMode(e.target.value);
                        }}
                        size="small"
                      >
                        <MenuItem value="SUBSCRIPTION">SUBSCRIPTION</MenuItem>
                        <MenuItem value="WITHHOLD">WITHHOLD</MenuItem>
                        <MenuItem value="REFUND">REFUND</MenuItem>
                        <MenuItem value="DISCOUNT">DISCOUNT</MenuItem>
                        <MenuItem value="OTHER">OTHER</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Stack>
                {uType === "CREDIT" && (
                  <>
                    <Typography className="mt-4" variant="h6">
                      Source
                    </Typography>{" "}
                    <FormControl fullWidth className="mt-3 mb-3">
                      <Select
                        disabled={genericLoad}
                        notched={false}
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={uSource}
                        label="Source"
                        onChange={(e) => {
                          setUsource(e.target.value);
                        }}
                        size="small"
                      >
                        <MenuItem value="PAYMENT_LINK">Payment Link</MenuItem>
                        <MenuItem value="BANK_TRANSFER">Bank Transfer</MenuItem>
                        <MenuItem value="CHEQUE">Cheque</MenuItem>
                        <MenuItem value="UPI">UPI</MenuItem>
                        <MenuItem value="OTHER">OTHER</MenuItem>
                      </Select>
                    </FormControl>
                  </>
                )}
                <Typography className="mb-3" variant="h6">
                  Description
                </Typography>{" "}
                <OutlinedInput
                  notched={false}
                  // disabled={true}
                  id="outlined-basic"
                  name="aboutUsFullText"
                  label="Description"
                  multiline
                  rows={5}
                  maxRows={25}
                  variant="outlined"
                  value={uDescription}
                  onChange={(e) => {
                    setUDescription(e.target.value);
                  }}
                  fullWidth
                  sx={{ width: "100%" }}
                  type="text"
                />
              </div>

              <div
                className="settleDuesSubmitBtns"
                style={{ marginTop: "0.75rem", marginBottom: 0 }}
              >
                <Button
                  className="cancelBtn"
                  size="small"
                  onClick={() => handleUpdateEnryClose()}
                >
                  Cancel
                </Button>
                <Stack direction="row" spacing={1}>
                  <Button
                    color="error"
                    size="small"
                    variant="outlined"
                    disabled={genericLoad || currentId === -1}
                    onClick={() => {
                      deleteLedgerEntryAPI();
                    }}
                    sx={{ minWidth: "6.5rem" }}
                  >
                    Delete
                  </Button>
                  <Button
                    size="small"
                    variant="custom-button"
                    disabled={genericLoad}
                    onClick={() => {
                      updateLedgerEntryAPI();
                    }}
                    sx={{ minWidth: "6.5rem" }}
                  >
                    {genericLoad ? (
                      <CircularProgress
                        size={15}
                        color="inherit"
                        sx={{ ml: 1.5 }}
                      />
                    ) : (
                      "Update"
                    )}
                  </Button>
                </Stack>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Pay Now Modal */}
      <Modal
        open={payNowModalOpen}
        onClose={handleClosePayNowModal}
        aria-labelledby="pay-now-modal-title"
        aria-describedby="pay-now-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 450,
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Pay Invoice
            </Typography>
            <IconButton size="small" onClick={handleClosePayNowModal}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ p: 3 }}>
            {payNowLedgerEntry && (
              <>
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                  >
                    Invoice ID: #{payNowLedgerEntry.id}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Description: {payNowLedgerEntry.description || "-"}
                  </Typography>
                </Box>

                {/* TDS Bifurcation */}
                {(() => {
                  const grossAmount =
                    parseFloat(payNowLedgerEntry.amount) || 0;
                  const tdsPercent = getTdsPercentage(
                    accountInfo?.account_details
                  );
                  const bifurcation = calculateTdsBifurcation(
                    grossAmount,
                    tdsPercent
                  );

                  return (
                    <Box
                      sx={{
                        bgcolor: "#f9f9f9",
                        p: 2,
                        borderRadius: 1,
                        mb: 3,
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{ mb: 2, fontWeight: 600 }}
                      >
                        Payment Summary
                        {tdsPercent > 0 && ` (TDS @ ${tdsPercent}%)`}
                      </Typography>
                      <Stack spacing={1.5}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography variant="body1">Gross Amount:</Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {formatCurrency(bifurcation.grossAmount, hotelCurr)}
                          </Typography>
                        </Box>
                        {tdsPercent > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography variant="body1" color="error">
                              TDS Deduction ({tdsPercent}%):
                            </Typography>
                            <Typography
                              variant="body1"
                              color="error"
                              sx={{ fontWeight: 500 }}
                            >
                              - {formatCurrency(bifurcation.tdsAmount, hotelCurr)}
                            </Typography>
                          </Box>
                        )}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            pt: 1.5,
                            borderTop: "1px dashed #ccc",
                          }}
                        >
                          <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            Net Payable:
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: 700, color: "#1ab394" }}
                          >
                            {formatCurrency(bifurcation.netPayable, hotelCurr)}
                          </Typography>
                        </Box>
                      </Stack>
                    </Box>
                  );
                })()}

                <Alert severity="info" sx={{ mb: 3 }}>
                  On successful payment, a GST invoice will be automatically
                  generated and sent to the registered billing email.
                </Alert>

                <Stack direction="row" spacing={2} justifyContent="flex-end">
                  <Button
                    variant="outlined"
                    onClick={handleClosePayNowModal}
                    disabled={payNowLoading}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: "#1ab394",
                      "&:hover": { bgcolor: "#158a70" },
                    }}
                    onClick={() => handlePayNowRazorpay(payNowLedgerEntry)}
                    disabled={payNowLoading}
                  >
                    {payNowLoading ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      `Pay ${formatCurrency(
                        calculateTdsBifurcation(
                          parseFloat(payNowLedgerEntry.amount),
                          getTdsPercentage(accountInfo?.account_details)
                        ).netPayable,
                        hotelCurr
                      )}`
                    )}
                  </Button>
                </Stack>
              </>
            )}
          </Box>
        </Box>
      </Modal>

      <Modal
        open={showPaymentLink}
        onClose={handleCloseShowPaymentLink}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="settleDuesModal" sx={modalStyle}>
          <div className="settleDuesWrapper">
            <div className="settleDuesHeader">
              <div className="settleDuesHeading">Payment link</div>
              <div
                className="close"
                onClick={() => handleCloseShowPaymentLink()}
              >
                X
              </div>
            </div>
            <div className="amountWrapper">
              <div className="fieldWrapper">
                <Typography>
                  Please open this link in incognito window
                </Typography>

                <h4 style={{ marginTop: "1rem" }}>
                  {`${getUrl()}pay-now/?group_id=${groupId}`}
                </h4>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default TransactionsManagement;

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  height: "80vh",
  overflowY: "auto",
};
